/**
 * 购物车
 */
 (function () {
  var countryInfo = LS.ui.countryInfoMap[LS.site.country];
  var pointRatio = LS.ui.pointRatio;
  var loadedUserCouponList = false;
  var originCartAmount = 0; // 原始购物车金额，未计算折扣
  var originCartNumber = 0; // 原始购物车数量
  var originCartItemList = []; // 原始购物车列表
  var originCartOnSellItemsDom = []; // 原始购物车在售商品dom
	var curShippingFreeText = '';
  var cartBody = $(".cart-content_wrapper");
  var INCREASE_TYPE = 1;
  var MINUS_TYPE = 0;
  var CHANGE_TYPE = 2;
  var cartList = [];
  var cartObj = {}; // 这里存的全部商品，包括售罄 {id: quantity}
  // 优惠券
	var storeCoupon = 'graecove_cart_coupon';
  var userCouponList = []; // 优惠券集合
  var userAvailableCouponList = []; // 用户可用优惠券
	var confirmUseCoupon = ''; // 选中使用的优惠券
	var confirmUseRedeemCode = ''; // 积分兑换的优惠券
  var curGiftVariantList = [];
  var isCartHasBedding = false; // 购物车是有有床品
	var beddingDiscountAmount = 0; // 购物车床品总折扣金额
	var isOpenBeddingDiscount = false; // 是否开放床品营销
	var giftSkuList = ['ZT2304002-Ginger-S', 'ZT2304002-Beige-S', 'ZT2304002-LightPink-S', 'ZT2304002-Chocolate-S', 'ZT2304002-LinenStripe-S', 'ZT2304002-OliveGreen-S', 'ZT2304002-GreenStripe-S'];
  // 购物车底部价格详情弹窗html模块
  var cartBottomPriceDetailModel = `
      <div class="btn-wrapper-pop-list-abt">
        <div class="poplist-title"><%t('bag.subtotal') %></div>
        <div class="poplist-value poplist-value-price mr-r"><%= data.subTotal %></div>
      </div>
      <div class="btn-wrapper-pop-list-abt btn-wrapper-pop-list-code" id="cart-edit-coupon-btn">
        <div class="poplist-title">
        <%t('bag.code') %>: <span id="ls-cart-coupon_code"><%= data.code %></span>
        </div>
        <div class="poplist-value poplist-value-price poplist-value-red">- <span><%= data.discountPrice %></span>
          <img class="poplist-value_img" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/cart_icon_right.png?v=1670325224" />
        </div>
      </div>
      <% if ( data.shippingStatus !== 0  ) { %>
        <div class="btn-wrapper-pop-list-abt btn-wrapper-pop-list-shipping">
          <div class="poplist-title"><%t('bag.shipping') %>: <span><%= data.shippingType %></span></div>
          <div class="poplist-value mr-r shipping-free"><%t('bag.shipping_free') %></div>
        </div>
      <% } %>
		  <div class="btn-wrapper-pop-tip-abt">
        <p><%t('bag.note_text_1') %></p>
        <p><%t('bag.note_text_2') %></p>
      </div>
      <% if ( data.isLogin && data.exchangePoints > 0 ) { %>
        <div class="cart-details_points-wrapper" id="cart-points-selector">
          <div class="cart-details_points-left">
            <span class="cart-details_points-label">Points reward: </span>
            <span class="cart-details_points-value"><%= data.exchangePoints %> pts</span>
          </div>
          <div class="cart-details_points-right <% if (data.exchangePoints <= 0) { %>without-exchange-points<% } %>">
            <span class="cart-details_points-amount" id="cart-points-amount" data-exchange-points-amount="<%= data.exchangePointsAmount %>" data-code="<%= data.exchangeCode %>"><%= data.amountByExchangePointsStr %></span>
            <div class="cart-details_points-checkbox icon-points-checkbox icon-points-checked"></div>    
          </div>
        </div>
      <% } %>	
    `;
  // 购物车底部免邮提示模块
	var cartBottomFreeMailTipsModel = `
    <% if ( data.cartDiscountTotal < data.standardPrice ) { %>
      <div class="shipping-item">
        <%t('bag.standard_shipping_buy', {symbol: data.symbol, price: LS.i18n.fmtAmount((data.standardPrice - data.cartDiscountTotal).toFixed(2))}) %>
      </div>
    <% } else if ( data.cartDiscountTotal >= data.standardPrice && data.cartDiscountTotal < data.expressPrice ) { %>
      <div class="shipping-item">
        <%t('bag.express_shipping_buy', {symbol: data.symbol, price: LS.i18n.fmtAmount((data.expressPrice - data.cartDiscountTotal).toFixed(2))}) %>
      </div>
    <% } %>
  `;
  var cartBottomFreeMailTipsModelTwo = `
    <% if ( data.cartDiscountTotal >= data.standardPrice && data.cartDiscountTotal < data.expressPrice ) { %>
      <div class="shipping-item">
        ${ LS.$t('bag.standard_shipping_free') }
      </div>
    <% } else if ( data.cartDiscountTotal >= data.expressPrice ) { %>
      <div class="shipping-item">
        <% if ( data.standardPrice != data.expressPrice ) { %>
          ${ LS.$t('bag.express_shipping_free') }
        <% } else { %>
          ${ LS.$t('bag.standard_shipping_free') }
        <% } %>
      </div>
    <% } %>
  `;

	var cartTipPopupHtml = `
		<div class="cart-tip-popup" id="cart-tip-popup">
			<img class="cart-tip-popup_trangle-icon" loading="lazy" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_tips_2x_70efe285-a2c5-49ac-becf-71a4cf074d7e_700x.png?v=1670306949">
			<div class="cart-tip-popup_text"></div>				
			<img class="cart-tip-popup_close" loading="lazy" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_close_light_2x_49a755a6-afd9-44ec-97f1-83e20f517fe1.png?v=1667463524" />
		</div>
	`

  // 优惠券编辑弹窗
	var couponListPopupHtml = `
  <div class="ls-main-popupbox ls-main-popupbox-coupon-edit">
    <div class="ls-main-popupbox-overlay" type="1"></div>
    <div class="ls-main-popupbox-con">
      <!-- 标题区域 -->
      <div class="main-popupbox-con-title">
        <p class="p-title">${ LS.$t('bag.available_coupons') }</p>
        <div class="title-close" type="2">
          <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-pop-close-icon.png?v=1657006987" />
        </div>
      </div>
      <!-- 内容区域 -->
      <div class="main-popupbox-con-model ls-pop-coupon-edit">
        <div class="ls-pop-coupon-edit-con">
          <!-- 输入code兑换优惠券区域 -->
          <div class="enter-coupon-code-model">
            <div class="coupon-code-box">
              <input class="coupon-code-inp" type="text" placeholder="Please enter your coupon code" spellcheck="false">
              <div class="exchange-coupon-code-btn" id="exchange-coupon-code-btn">
                <img class="icon" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/coupon_code_back.png?v=1670470996" />
              </div>
            </div>
            <p class="code-error-tip"></p>
          </div>
          <!-- 可使用优惠券区域 -->
          <div class="con-coupon-list available-coupon-list"></div>
          <!-- 积分兑换优惠券区域 -->
          <div class="con-coupon-list redeem-coupon-list"></div>
          <!-- 不可使用优惠券区域 -->
          <div class="not-available-coupon-module"></div>
          <!-- 底部按钮区域 -->
          <div class="coupon-edit-footer fix-padding-bot">
            <div class="cart-coupon-pop-confirmbtn">${ LS.$t('bag.coupon_confirm_btn') }</div>
          </div>
        </div>
      </div>
    </div>
  </div>
`;

  // redeem兑换弹窗
  var redeemPopHtml = `
    <div class="ls-vertical-popupbox ls-vertical-popupbox-redeempop">
      <div class="ls-vertical-popupbox-overlay"></div>
      <div class="ls-vertical-popupbox-con">
        <!-- 内容区域 -->
        <div class="con-modelbox">
          <div class="con-modelbox-head">
            <!-- 删除区域 -->
            <div class="con-close-btn">
              <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-coupon-redeem-close.png?v=1658310516" />
            </div>
            <p class="p1"><%t('bag.redeem_points', '', 1) %></p>
          </div>
          <p class="point-tip"><%t('bag.redeem_consumption_points', { redeemPointsAmount: data.redeemPointsAmount }, 1) %></p>
          <div class="con-modelbox-exchange">
            <div class="exchange-left">
              <p class="p1"><%= data.redeemPointsAmount %></p>
              <p class="p2"><%t('bag.points_text', '', 1) %></p>
            </div>
            <img class="exchange-con" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-coupon-exchange-icon.png?v=1658310517" />
            <div class="exchange-right">
              <p class="p1"><%= data.currencySymbol %><span><%= data.currencyCode %><%= data.redeemCouponAmount %></span></p>
            </div>
          </div>
          <div class="redeem-confirm-btn" amount="<%= data.redeemCouponAmount %>" redeemId="<%= data.pointsCouponRedeemSettingsId %>"><%t('bag.coupon_redeem_btn', '', 1) %></div>
        </div>
      </div>
    </div>
  `;

  var giftModuleHtml = `
		<img class="gift-label" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/tag_free_gift_2x_0274feac-0b9f-43fd-97c6-01a796e3e0c5.png?v=1684907926" />
		<img class="gift-rule-btn" src ="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_RULES_2x_589417ac-b788-4cea-aaa0-4272da454876.png?v=1684907926" />
		<% if (data.hasGiftDiffAmount) { %>
			<div class="gift-tip">Just <span class="gift-tip-bold">${countryInfo.symbol}<%= data.hasGiftDiffAmount %></span> away from <span class="gift-tip-bold">a free pillowcase</span>. Limited quantity, first come first served!</div>
		<% } else { %>
			<div class="gift-tip"><span class="gift-tip-bold">Rest Easy With FREE Pillowcases On Orders Over $219</span></div>
		<% } %>
		<div class="gift-item gift-selector" <% if (data.hasGiftDiffAmount) { %>data-has-diff-amount="<%= data.hasGiftDiffAmount %>"<% } %> data-type="1">
			<div class="gift-item-inner">
				<div class="gift-item-checkbox <% if (data.hasGiftDiffAmount) { %>disabled<% } %>"></div>
				<div class="gift-item_product">
					<div class="gift-item_product-img-box js-lazyload-img">
						<img
							class="gift-item_product-img"
							data-lazyload-src="<%= data.image.src %>"
							object-fit="contain"
						/>
					</div>
					<div class="gift-item_product-info-box">
						<div class="gift-item_product-name"><%= data.title %></div>
						<div class="gift-item_product-size">Size: Standard</div>
						<div class="gift-item_product-color-wrapper">
							<div class="gift-item_product-color-text">Color: <span class="gift-item_product-selected-color">Please Choose</span></div>
							<img class="gift-item_product-color-arrow" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_back_light_s_5_2x_1a6cddd1-bf43-40e7-82a3-a886d07e4c4d.png?v=1684907926" />
						</div>
					</div>
				</div>
			</div>
			<div class="gift-item-tip-wrapper">Note: We'll try to match your color choice, but we may substitute with an available color due to inventory limitations. Limited quantity, first come first served!</div>
		</div>
		<div class="no-gift-wrapper gift-selector" <% if (data.hasGiftDiffAmount) { %>data-has-diff-amount="<%= data.hasGiftDiffAmount %>"<% } %> data-type="2">
			<div class="gift-item-inner">	
				<div class="gift-item-checkbox no-gift-checkbox <% if (data.hasGiftDiffAmount) { %>disabled<% } %>"></div>  
				<div class="no-gift-text">No need for a free gift</div>  
			</div>
			<div class="gift-item-tip-wrapper">You've opted out of the gift. We respect your choice and will process your order accordingly. Thank you for your support.</div>
		</div>
	`;
  
	// 赠品选择颜色弹窗
	var giftColorSelectorDom = `
		<div class="gift-color-selector_label">Color: <span id="gift-color-selector">Please choose</span></div>
		<div class="gift-color-selector_color-wrapper">
			<% for ( var item of data ) { %>
				<% if (item.stockQuantityFromSupplyChain - item.waitingQuantityFromSupplyChain > 0) { %>
					<div class="gift-color-selector_color-item" data-sku="<%= item.sku %>" data-img="<%= item.image.src.replace(".jpg", "_180x.jpg").replace(".png", "_180x.png") %>">
						<img class="gift-color-selector_color-img" src="<%= item.image.src.replace(".jpg", "_100x.jpg").replace(".png", "_100x.png") %>" />
					</div>
				<% } %>	
			<% } %>
		</div>
		<div class="gift-color-selector-submit-btn-wrapper">
			<div class="common-submit-button gift-color-selector-submit-btn" id="gift-color-selector-submit-btn">Save</div>
		</div>
	`;

  var giftRulesDom = `
		<div class="gift-rules-inner">
			<div class="gift-rules-header">Rules</div>
			<div class="gift-rules-content">
				<div class="commcon-page-text">Welcome to our "Free Gift" promotion! The promotion starts <span class="commcon-page-text-bold">at 00:00:00 on May 29, 2023</span>, and ends <span class="commcon-page-text-bold">at 23:59:59 on May 29, 2023.</span></div>
				<div class="commcon-page-text">When your order total (<span class="commcon-page-text-bold">after using discount coupons</span>) reaches or exceeds $219, you can receive a pair of our selected standard size pillowcases for free. We offer 7 colors for you to choose from.</div>
				<div class="commcon-page-text">Please note that while we will do our best to arrange delivery based on your color selection, if the color you chose is out of stock, we may randomly choose another color that is in stock for you. Additionally, the number of gifts is limited, and it's first come first served. The promotion will end immediately once all gifts are given out.</div>
				<div class="commcon-page-text">Once you meet the conditions, you can choose your favorite gift color in [My Bag]. If you choose not to accept the gift, we will also respect your choice.</div>
				<div class="commcon-page-text">Please note: If you accept the gift, be sure to select the gift and its color before checking out, otherwise we will consider it as a waiver.</div>
				<div class="commcon-page-text">The gift will be shipped out with your order items. Thank you for your support and happy shopping!</div>
			</div>
		</div>
	`;

  var cartFn = {
    getOriginCartAmount() {
      var res = $('#looksky-cart-bag_pc').length ? Number($('#looksky-cart-bag_pc').attr('value')) / 100 : originCartAmount;
			return res;
		},
    getExchangePointsInfo() {
			var points = 0;
			var code = '';
			var userVipInfo = LS.userVipInfo;
			var userPointsInfo = userVipInfo && userVipInfo.userPointsInfo;
			if (userVipInfo !== undefined && userPointsInfo) {
				var exchangePoints = userPointsInfo.exchangePoints;
				var giftCardCode = userPointsInfo.giftCardCode;
				if (exchangePoints && exchangePoints > 0) {
					points = exchangePoints;
				}
				if (giftCardCode) {
					code = giftCardCode;
				}
			}
			return { points: points, code: code };	
		},
		getShippingData(total) {
			var standard = countryInfo.standard;
			var express = countryInfo.express;
			// 有快邮门槛且达到快邮门槛
			if (express !== standard && total >= express) {
				return {
					shippingType: 2,
					shippingAmount: 0
				};
			}

			if (total >= standard) {
				return {
					shippingType: 1,
					shippingAmount: 0
				}
			}

			return {
				shippingType: 0,
				shippingAmount: countryInfo.standardPostage
			}
		},
		getAmountByExchangePoints(points) {
			if (points <= 0) return 0;
			// 兑换现金至$0.01
			return Math.ceil( points * 100 / pointRatio) / 100;
		},
    /**
     * 通过ls-cart-data.liquid获取最新的购物车商品状态，主要获取库存和是否售罄
     */
    handleSubmit: function () {
      LS.ajax({
        url: LS.ui.routes.getCarJSONUrl,
        dataType: "html",
        success: function (res) {
          var responseHTML =
            JSON.parse(res || "null")["looksky-cart-data"] || "";
          var $data = $(`<div>${responseHTML}</div>`);
          var cartItemsDOM = $data.find(".cart-item") || [];
          cartList = [];
          $.each(cartItemsDOM, function (index, item) {
            var json =
              JSON.parse($(item).find(".cart-json").text() || "null") || {};
            var itemMetafieldsInfo =
              JSON.parse(
                $(this).find(".itemMetafieldsInfo").text() || "null"
              ) || "";
            var inventory_management =
              $(this).find(".inventory_management").text() || "";
            var inventory_quantity =
              $(this).find(".inventory_quantity").text() || "";
            var isSoldout = false; // 默认没售罄
            if (itemMetafieldsInfo) {
              var isOffShelf = itemMetafieldsInfo.status !== "active"; // 下架
              var variants = itemMetafieldsInfo.variants || []; // 商品sku
              var targetVariant = variants.find(
                (item) => item.id === json.variant_id
              );
              if (targetVariant) {
                // 售罄条件：下架、库存策略为shopify且库存数量为0、soldOutStatus为1且sellType为1
                isSoldout =
                  isOffShelf ||
                  (inventory_management === "shopify" &&
                    inventory_quantity < 1) ||
                  (targetVariant.soldOutStatus === 1 &&
                    targetVariant.sellType === 1) || 
                  LS.ui.isOtherCountrySoldout(targetVariant.otherCountrySellable);
              }
            }
            json.inventory_quantity = inventory_quantity; // 库存量
            json.isSoldout = isSoldout; // 是否售罄
            cartList.push(json);
          });
          cartFn.checkCartAvailable(cartList);
        },
        error: function (e) {
          // LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    },
    /**
     * 售罄片段
     * @returns
     */
    renderSoldoutSlot: function () {
      var getSoldoutList = $("#sold-out-items").find(".cart-item_container");
      var len = getSoldoutList.length;
      var cartItems = "";
      var obj = {};
      if (len > 0) {
        for (var i = 0; i < len; i++) {
          var itemData =
            JSON.parse(
              $(getSoldoutList[i]).find(".js-product-json").text() || "null"
            ) || {};
          obj[itemData.id] = 0;
          // 添加货币code
          itemData.currencyCode = countryInfo.symbolCode;
          cartItems += cartFn.renderCartItem(itemData);
        }
      }
      obj = JSON.stringify(obj) || {};
      var slot = `
        <div class="cart-slot_wrapper">
          <p class="cart-slot_tip">${ LS.$t('bag.delete_subtext', '', 1) }</p>
          <div class="cart-solt_cart-items">${cartItems}</div>
          <div class="cart-slot_btn" id="confirm-delete-all-soldout" data-soldout=${obj}>${ LS.$t('bag.delete_btn', '', 1) }</div>
        </div>
      `;
      return slot;
    },
    /**
     * 检查购物车商品库存数量和是否售罄
     */
    checkCartAvailable: async function (arr) {
      var onSellItems = $("#on-sell-items").find(".cart-item_container");
      var soldoutItems = $("#sold-out-items").find(".cart-item_container");
      var onSellItemsLen = onSellItems.length;
      var soldoutLen = soldoutItems.length;
      var cartItems = "";
      var shouldHandleDelete = false;
      // 处理在售商品
      if (onSellItemsLen > 0) {
        for (var i = 0; i < onSellItemsLen; i++) {
          var onSellItemData =
            JSON.parse(
              $(onSellItems[i]).find(".js-product-json").text() || "null"
            ) || {};
          var onSellItemQuantity = onSellItemData.quantity || 0;
          var onSellItemCartId = onSellItemData.id;
          // cartJSON 对比的对象
          var onSellTarget = arr.find((item) => item.id + '' === onSellItemCartId);
          cartObj[onSellItemCartId] = onSellItemQuantity;
          // 对比cartJson数据
          if (onSellTarget) {
            // 获取库存数
            var max_quantity =
              Number.parseInt(onSellTarget.inventory_quantity) || 9999;
            // 判断是否售罄
            var isSoldout = onSellTarget.isSoldout || false;
            // 如果库存数小于当前选购数量，将选购数量设置为库存数，并cartItems添加上dom节点，设置shouldHandleDelete为true，需要弹窗
            if (max_quantity > 0 && max_quantity < onSellItemQuantity) {
              onSellItemData.max_quantity = max_quantity;
              cartObj[onSellItemCartId] = max_quantity;
              // 添加货币code
              onSellItemData.currencyCode = countryInfo.symbolCode;
              cartItems += cartFn.renderCartItem(onSellItemData);
              shouldHandleDelete = true;
            }
            // 如果刚好售罄，将isSoldout设置为true，数量设置为0，同时cartItems添加上dom节点
            if (isSoldout) {
              onSellItemData.isSoldout = isSoldout;
              cartObj[onSellItemCartId] = 0;
              // 添加货币code
              onSellItemData.currencyCode = countryInfo.symbolCode;
              cartItems += cartFn.renderCartItem(onSellItemData);
              shouldHandleDelete = true;
            }
          }
        }
      }
      // 处理当前售罄商品
       if (soldoutLen > 0) {
        for (var i = 0; i < soldoutLen; i++) {
          var soldoutItemData =
            JSON.parse($(soldoutItems[i]).find('.js-product-json').text() || 'null') || {};
          var soldoutItemCartId = soldoutItemData.id;
          cartObj[soldoutItemCartId] = 0;
        }
      }
      // 需要弹窗
      if (shouldHandleDelete) {
        var obj = JSON.stringify(cartObj) || {};
        var slot = `
          <div class="cart-slot_wrapper" id="cart-slot">
            <p class="cart-slot_tip">${ LS.$t('bag.delete_subtext2', '', 1) }</p>
            <div class="cart-solt_cart-items">${cartItems}</div>
            <div class="cart-slot_btn" id="check-submit" data-handle-items=${obj}>${ LS.$t('bag.delete_btn2', '', 1) }</div>
          </div>
        `;
        LS.ui.renderBottomDrawer(
          {
            title: LS.$t('bag.sold_out_title', '', 1),
            slot,
          },
          "checkout"
        );
      } else {
				// LS.ui.loadingPopShow();
        // await LS.ui.handleCheckout(cartObj);
				// LS.ui.loadingPopHide();
        cartFn.updateCart(cartObj);
      }
    },
		/**
     * 更新购物车商品数量
     * @param {} obj 	
     * updates: {
          794864053: 0,
          794864233: 0
        }
     */
    updateCart: function (obj) {
      LS.ajax({
        url: LS.ui.routes.updateCartItemUrl,
        type: "POST",
        data: {
          updates: obj,
        },
        success: function () {
          $("#submit-hidden-btn").click();
        },
        error: function (e) {
          LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    },
		// updateCart: function (obj) {
		// 	LS.ui.loadingPopShow();
		// 	LS.ajax({
		// 		url: LS.ui.routes.updateCartItemUrl,
		// 		type: "POST",
		// 		data: {
		// 			updates: obj,
		// 		},
		// 		success: async function () {
		// 			var onsellObj = {};
		// 			for (var cartId in cartObj) {
		// 				if (cartObj[cartId] !== 0) {
		// 					onsellObj[cartId] = cartObj[cartId];
		// 				}
		// 			}
		// 			await LS.ui.handleCheckout(onsellObj);
		// 		},
		// 		error: function (e) {
		// 			LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
		// 			LS.ui.loadingPopHide();
		// 		},
		// 	});
		// },
    /**
     * 获取购物车data数据
     * handleType: 1为加购
     */
    getCartDataInfo: function (type, handleType, callback, firstLoad) {
      return new Promise(function(resolve, reject) {
        LS.ajax({
          url: LS.ui.routes.getCarJSONUrl,
          dataType: "html",
          success: async function (res) {
            var responseHTML =
              JSON.parse(res || "null")["looksky-cart-data"] || "";
            var $data = $(`<div>${responseHTML}</div>`);
            var cartDOM = $data.find(".cart-data") || "null";
            var acount = $(cartDOM).find(".acount").text() || 0;
            var total = $(cartDOM).find(".total").text() || 0;
            var cartItemsJSON = $(cartDOM).find('.cart-items') ? $(cartDOM).find('.cart-items').text() : '[]';
						originCartOnSellItemsDom = $(cartDOM).find('.on-sell-cart-items .cart-item_container-box') || [];
            originCartAmount = Number(total) / 100;
            originCartNumber = Number(acount);
						originCartItemList=  JSON.parse(cartItemsJSON) || [];
            $('#looksky-cart-bag_pc').attr('value', total);
            // 显示修改head中购物车数量
            if (acount < 1) {
              $(".ls-header-cart-count").hide();
            } else if (acount >= 1 && acount < 100) {
              $(".ls-header-cart-count").text(acount);
              $(".ls-header-cart-count").show();
            } else {
              $(".ls-header-cart-count").text("99+");
              $(".ls-header-cart-count").show();
            }
            // 根据abtest类型以及购物车数量，进行不同形态的展示的方法
            // cartFn.cartCountAbtestHandle(acount, type);
            if (!loadedUserCouponList) {
							await cartFn.getCartCouponList();
						}
						loadedUserCouponList = true;
           // 获取优惠券信息
						cartFn.handleCouponMaxDiscount();
						// 调用底部checkout区域abt方法
						cartFn.cartBottomCheckoutModelHanlde(firstLoad);
						// 匹配差额享折扣
						cartFn.handleMatchDiscount(handleType);

            // 商详页加购时，计算再加购该商品可享受的优惠
            if (LS.site.page === 'product' && handleType === 1) {
              cartFn.insertProductDiscountModule();
            }

            callback && typeof callback === "function" && callback(total);
            resolve();
          },
          error: function() {
						reject();
					}
        });
      });
    },
    /**
		 * 判断优惠券是否可用
		 * @param {*} couponItem 
		 * @param {*} cartAmount 
		 * @param {*} cartNumber 
		 * @returns 
		 */
		getCouponVailable: function(couponItem, couponCategory, cartAmount, cartNumber) {
			var discountMinimalPurchaseAmount = couponItem.discountMinimalPurchaseAmount ? Number(couponItem.discountMinimalPurchaseAmount) * LS.site.rate : 0;
			var userCouponType = couponItem.userCouponType;
			var couponMinCount = couponItem.minimalProductCount;
      var redeemCouponAmount = couponItem.redeemCouponAmount;
			// 优惠券折扣金额大于购物车总金额
			if (redeemCouponAmount && Number(redeemCouponAmount) > cartAmount) {
				return false;
			}
			// 用户优惠券类型: userCouponType @unused:1:未使用 @used:2:已使用 @expired:3:已过期
			return userCouponType == 1 // 1未使用
				&& (couponCategory === 1 && discountMinimalPurchaseAmount <= cartAmount) // 满减券
					|| (couponCategory === 2 && couponMinCount <= cartNumber) // 多件梯度券
					|| (couponCategory === 3 && discountMinimalPurchaseAmount === 0); // 无门槛券 
		},
    /**
		 * 优惠券类别
		 * @param {object} couponItem  优惠券数据
		 * @returns 1: 满减券 2: 多件梯度券 3: 无门槛券
		 */
		getCouponCategory: function(couponItem) {
			var discountMinimalPurchaseAmount = couponItem.discountMinimalPurchaseAmount;
			var redeemCouponAmount = couponItem.redeemCouponAmount;
			var couponMinCount = couponItem.minimalProductCount;
			// 如果有category优惠券类别且有minimalProductCount，为多件梯度券
			if (couponMinCount > 0) return 2;
			if (discountMinimalPurchaseAmount && redeemCouponAmount !== '0') return 1;
			if (!discountMinimalPurchaseAmount) return 3;
		},
		calcCouponDiscountAmount: function(couponItem, vailable, cartAmount) {
			var discountAmount = 0;
			if (vailable) {
				var redeemCouponAmount = couponItem.redeemCouponAmount;
				var discountPercentage = couponItem.discountPercentage;
				if (redeemCouponAmount && redeemCouponAmount > 0) { // 金额满减券
					discountAmount = (Number(redeemCouponAmount) * LS.site.rate).toFixed(2);
				} else if (discountPercentage && discountPercentage !== '0') { // 百分比折扣券
					discountPercentage = Number(discountPercentage.replace('%', ''));
					discountAmount = (Math.floor(cartAmount * 100 * (discountPercentage / 100)) / 100).toFixed(2);
				}
			}

      if (couponItem.isProductCoupon) {
				discountAmount = (beddingDiscountAmount / 100).toFixed(2);
			}

			return discountAmount;
		},
		recomNextDiscount: function(switchCoupon) {
      switchCoupon = switchCoupon || false;
			var list = cartFn.handleCouponFields();
			var mutiCountDiscountList = [];
			var recomCoupon = '';
			if (list.length) {
				mutiCountDiscountList = list.filter(item => item.couponCategory === 1 && !item.vailable);
				if (mutiCountDiscountList.length) {
					mutiCountDiscountList = mutiCountDiscountList.sort(function(a, b) {
						return a.diffAmount - b.diffAmount
					})

					var maxMutiCountCoupon = mutiCountDiscountList[0];
					var compareAmount = maxMutiCountCoupon.discountMinimalPurchaseAmount;
					
					recomCoupon = cartFn.filterBestCouponItem(compareAmount, originCartNumber + 1, switchCoupon);
				} else {
					cartAmount = cartFn.getOriginCartAmount();
					recomCoupon = cartFn.filterBestCouponItem(cartAmount, originCartNumber + 1, switchCoupon);
				}
				cartFn.handleCartDiscountAboutCoupon(recomCoupon, switchCoupon);
			}
		},
		filterBestCouponItem: function(cartAmount, cartNumber, switchCoupon, preBeddingDiscountAmount) {
			cartAmount = cartAmount || cartFn.getOriginCartAmount();
			cartNumber = cartNumber || originCartNumber;
			var allAvailableCouponList = cartFn.filterAvailableCouponList(cartAmount, cartNumber);
			allAvailableCouponList = allAvailableCouponList.filter(item => item.discountCode !== 'Gift15' && item.discountCode !== 'Gift20' && !item.isProductCoupon);
      var maxDiscountCoupon = cartFn.filterMaxDiscountCoupon(allAvailableCouponList, switchCoupon, preBeddingDiscountAmount);
			return maxDiscountCoupon;
		},
    removeBeddingCoupon: function() {
			var idx = userCouponList.findIndex(item => item.discountId === '666');
			if (idx >= 0) {
				userCouponList.splice(idx, 1);
				localStorage.removeItem(storeCoupon);
			}
		},
		addBeddingCoupon: function(switchCoupon) {
      if (switchCoupon) return;
			var idx = userCouponList.findIndex(item => item.discountId === '666');
			LS.ui.beddingCoupon.discountAmount = (beddingDiscountAmount / 100).toFixed(2);
			localStorage.setItem(storeCoupon, JSON.stringify(LS.ui.beddingCoupon));
			if (idx < 0) {
				userCouponList.push(LS.ui.beddingCoupon);
			}
		},
		filterMaxDiscountCoupon: function(arr, switchCoupon, preBeddingDiscountAmount) {
			var len = arr.length;
      beddingDiscountAmount = 0;
			var maxDiscountCoupon = null;
			var hasBedding = false;
			if (isOpenBeddingDiscount) {
				var cartSellItemsDom = originCartOnSellItemsDom;
				var cartSellItemsDomLen = cartSellItemsDom.length;
				if (cartSellItemsDomLen) {
					for (var i = 0; i < cartSellItemsDomLen; i++) {
						var cartSellItem = $(cartSellItemsDom[i]);
						var isKindBelong = LS.ui.isKindBelong ? LS.ui.isKindBelong(3, cartSellItem) : '';
						var isBedding = isKindBelong.bedding || false;
						if (isBedding) {
							hasBedding = true;
							var beddingPrice = cartSellItem.find('.price').attr('data-price');
							var beddingQuantity = cartSellItem.find('.quantity').attr('value');
							beddingDiscountAmount = beddingDiscountAmount + (beddingPrice * beddingQuantity * 0.2);
						}
					}
				}
			}
			isCartHasBedding = hasBedding;
      if (isOpenBeddingDiscount) {
        if (!len) {
          if (isCartHasBedding || preBeddingDiscountAmount > 0) {
            maxDiscountCoupon = LS.ui.beddingCoupon;
            cartFn.addBeddingCoupon(switchCoupon);
            return LS.ui.beddingCoupon;
          } else {
            cartFn.removeBeddingCoupon();
          }

          return '';
        }
      }

      arr = arr.sort(function(a, b) {
				return b.couponCategory - a.couponCategory
			})
			maxDiscountCoupon = arr[0];
			for (var i = 0; i < len; i++) {
				var curCoupon = arr[i];
				if (Number(maxDiscountCoupon.discountAmount) < Number(curCoupon.discountAmount)) {
					maxDiscountCoupon = curCoupon
				}
			} 

      if (isOpenBeddingDiscount) {
        if ((isCartHasBedding && beddingDiscountAmount > (maxDiscountCoupon.discountAmount * 100)) || preBeddingDiscountAmount * 100 > (maxDiscountCoupon.discountAmount * 100)) {
          maxDiscountCoupon = LS.ui.beddingCoupon;
          cartFn.addBeddingCoupon(switchCoupon);
        } else {
          cartFn.removeBeddingCoupon();
        }
      }

			return maxDiscountCoupon;
		},
    /**
		 * 处理优惠券字段
		 * @param {*} cartAmount 
		 * @param {*} arr 
		 * @param {*} cartNumber 
		 * @returns 
		 */
		 handleCouponFields: function(cartAmount, cartNumber) {
			cartAmount = cartAmount || cartFn.getOriginCartAmount();
			cartNumber = cartNumber || originCartNumber;
			var arr = userCouponList;
			var len = arr.length;
			var list = [];
			if (!len) return [];
			for(var i = 0; i < len; i++) {
				var couponItem = arr[i];
				var discountMinimalPurchaseAmount = couponItem.discountMinimalPurchaseAmount ? Number(couponItem.discountMinimalPurchaseAmount) : 0;
				var couponCategory = cartFn.getCouponCategory(couponItem);
				var vailable = cartFn.getCouponVailable(couponItem, couponCategory, cartAmount, cartNumber);
				var diffAmount = discountMinimalPurchaseAmount !== 0 ? (Math.abs(discountMinimalPurchaseAmount - cartFn.getOriginCartAmount())).toFixed(2) : -1;
				var discountAmount = cartFn.calcCouponDiscountAmount(couponItem, vailable, cartAmount);
        var couponMemberCategory = couponItem.couponMemberCategory || 1; // 1会员券 2非会员券
        list.push({ 
					...couponItem, 
					discountAmount: discountAmount, 
					vailable: vailable, 
					diffAmount: diffAmount, 
					discountMinimalPurchaseAmount: discountMinimalPurchaseAmount,
					couponCategory: couponCategory,
          couponMemberCategory: couponMemberCategory
				});
			}
			return list;
		},
    // 判断单条优惠券的可用状态
    getSingleDiscountInfo: function(couponItem, cartAmount, cartNumber) {
      cartAmount = cartAmount || cartFn.getOriginCartAmount();
      cartNumber = cartNumber || originCartNumber;
      var discountMinimalPurchaseAmount = couponItem.discountMinimalPurchaseAmount ? Number(couponItem.discountMinimalPurchaseAmount) : 0;
			var couponCategory = cartFn.getCouponCategory(couponItem);
			var vailable = cartFn.getCouponVailable(couponItem, couponCategory, cartAmount, cartNumber);
			var diffAmount = discountMinimalPurchaseAmount !== 0 ? (Math.abs(discountMinimalPurchaseAmount - cartFn.getOriginCartAmount())).toFixed(2) : -1;
			var discountAmount = cartFn.calcCouponDiscountAmount(couponItem, vailable, cartAmount);
      var couponMemberCategory = couponItem.couponMemberCategory || 1; // 1会员券 2非会员券
      couponItem.vailable = vailable;
      couponItem.discountAmount = discountAmount;
      couponItem.diffAmount = diffAmount;
      couponItem.couponCategory = couponCategory;
      couponItem.couponMemberCategory = couponMemberCategory;
      return couponItem;
    },
    /**
		 * 默认过滤可用优惠券
		 * isVailable为false 过滤不可用优惠券
		 */
		filterAvailableCouponList: function(cartAmount, cartNumber, needUpdate, isVailable) {
			cartAmount = cartAmount || cartFn.getOriginCartAmount();
			cartNumber = cartNumber || originCartNumber;
      isVailable = isVailable !== undefined  ? isVailable : true;
			needUpdate = needUpdate !== undefined ? needUpdate : true;
			var sortList = cartFn.handleCouponFields(cartAmount, cartNumber);
			var arr = sortList.filter(item => item.vailable === isVailable);

			needUpdate && (userAvailableCouponList = arr);
			return arr;
		},
    /**
		 * 处理购物车优惠券优惠文案
		 */
		handleCartDiscountAboutCoupon: function(couponInfo, switchCoupon) {
			var cartAmount = cartFn.getOriginCartAmount();
			var discountShippingText = '';
			var diffShppingAmountStr = '';
			var symbolCode = countryInfo.symbolCode + countryInfo.symbol;
			var marketAbtestResObj = LS.ui.getMarketAbtestResult && LS.ui.getMarketAbtestResult() || {};
			var isLogin = marketAbtestResObj.isLogin || LS.ui.isLogin() || false;
			var isShowMarketModule = marketAbtestResObj.isShowModule || false;
      if (isShowMarketModule) {
        var currencySymbol = couponInfo.currencySymbol;
        var currencyCode = couponInfo.currencyCode;
        var discountPercentage = couponInfo.discountPercentage;
        var discountAmount = couponInfo.discountAmount;
        var diffAmount = couponInfo.diffAmount;
        var minCount = couponInfo.minimalProductCount;
        var discountMinimalPurchaseAmount = couponInfo.discountMinimalPurchaseAmount;
        var couponMemberCategory = couponInfo.couponMemberCategory;
        var discountCouponText = '';
        var discountAmountStr = '';
        var reachedMaxDiscountInfo = cartFn.isReachedMaxDiscountInfo(couponInfo);
        var couponCategory = reachedMaxDiscountInfo.couponCategory;
        var isReachedMaxDiscount = reachedMaxDiscountInfo.isReachedMaxDiscount;
        if (couponInfo.isProductCoupon && !switchCoupon) {
					discountCouponText = '20% Off All Bedding';
				} else if (couponCategory === 1) {
          discountAmountStr = currencySymbol + currencyCode + discountAmount;
          if (isReachedMaxDiscount || originCartNumber > 1) {
            if (switchCoupon || originCartNumber > 1) {
              discountAmount = confirmUseCoupon.discountAmount;
              discountAmountStr = currencySymbol + currencyCode + discountAmount;
            }
            discountCouponText = `You've got ${discountAmountStr} Off`;
          } else {
            discountCouponText = `Add <span>${currencySymbol + currencyCode + diffAmount}</span> more to get <span>${ discountAmountStr }</span> Off.`;
          }
        } else if (couponCategory === 2) {
          if (isReachedMaxDiscount || originCartNumber > 1) {
            if (switchCoupon || originCartNumber > 1) {
              discountAmount = confirmUseCoupon.discountAmount;
              discountAmountStr = currencySymbol + currencyCode + discountAmount;
              discountCouponText = `You've got ${discountAmountStr} Off`;
            } else {
              discountCouponText =	`You've got ${discountPercentage} Off`; 
            }
          } else {
            if (originCartNumber > 1) {
              discountCouponText = `Buy any one more and get ${discountPercentage} Off.`;
            } else {
              discountCouponText = `Buy ${ minCount } get ${discountPercentage} Off.`;
            }
          }
        } else {
          discountAmountStr = currencySymbol + currencyCode + discountAmount;
          discountCouponText = `You've got ${discountPercentage ? discountPercentage : discountAmountStr} Off`; 
        }

        var curCouponDiscount = confirmUseCoupon && confirmUseCoupon.discountAmount ? confirmUseCoupon.discountAmount : 0;
        var curShippingFreeText = cartFn.handleHasShippingFree(cartAmount - curCouponDiscount);
        // 满减折扣或者凑单、多件满减已达最大优惠，或推荐的是无门槛
        if (isReachedMaxDiscount || originCartNumber > 1) {
          curShippingFreeText !== '' && (discountShippingText = `and enjoy ${curShippingFreeText}.`);
        } else if (discountMinimalPurchaseAmount) {
          var preShippingFreeCartAmount = discountMinimalPurchaseAmount - discountAmount;
          var shippingFreeText = cartFn.handleHasShippingFree(preShippingFreeCartAmount);
          if (curShippingFreeText !== 'Free Express Shipping' && shippingFreeText !== curShippingFreeText) {
            shippingFreeText !== '' && (discountShippingText = `and enjoy ${shippingFreeText}.`);
          }
        }

        if (discountCouponText || discountShippingText) {
          cartFn.insertCartDiscountModule({
            discountText: discountCouponText,
            shippingFreeText: discountShippingText,
            discountIcon: cartFn.getDiscountTipIcon(couponMemberCategory),
            couponMemberCategory: couponMemberCategory
          });
        } else {
          if (!isLogin) {
            cartFn.insertCartDiscountModule({
              discountText: 'Join for an Exclusive <span>10% Off</span>',
              discountIcon: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/cVIP_2x_1e289150-5a44-4ae3-9416-a66655d4e530_120x.png?v=1673331765',
              moduleType: 1
            });
          }
        }
      }
		},
    /**
		 * 是否已达到最大优惠反馈信息
		 * @param {} couponItem 
		 */
		isReachedMaxDiscountInfo: function(couponItem) {
			var couponCategory = couponItem.couponCategory;
			var discountMinimalPurchaseAmount = couponItem.discountMinimalPurchaseAmount;
			var minCount = couponItem.minimalProductCount;
			var cartAmount = cartFn.getOriginCartAmount();
			var isReachedMaxDiscount = false;
			if (couponCategory === 1) {
				if (discountMinimalPurchaseAmount <= cartAmount) {
					isReachedMaxDiscount = true;
				}
			} else if (couponCategory === 2) {
				if (minCount <= originCartNumber) {
					isReachedMaxDiscount = true;
				}
			} else {
				isReachedMaxDiscount = true;
			}

			return {
				couponCategory: couponCategory,
				isReachedMaxDiscount: isReachedMaxDiscount
			}
		},
    insertCartDiscountModule: function(opts) {
      if (!LS.ui.isFunctionOpenCountry()) return; 
      // moduleType 1: 引导注册 2: 折扣提醒
      var text1 = opts.discountText || '';
			var text2 = opts.shippingFreeText || '';
			var discountIcon = opts.discountIcon || '';
			var moduleType = opts.moduleType || 2;
      var couponMemberCategory = opts.couponMemberCategory || 2;
			var cartDiscountDom = `
				<div class="cart-discount-module ${moduleType === 1 ? 'cart-discount-module_register-btn' : ''}" data-discount-tip-type="${couponMemberCategory}">
					<div class="cart-discount-module_left">
						<img class="cart-discount-tip_left-icon ${moduleType === 1 ? 'regiseter-icon' : ''}" src="${discountIcon}" />
					</div>
					<div class="cart-discount-module_right">
						<div class="cart-discount-module_text">
							${text1 !== '' ? `<p>${text1}</p>` : ''}
							${text2 !== '' ? `<p>${text2}</p>` : ''}
						</div>

						${moduleType === 1 ? '<i class="cart-discount-module_right-arrow-icon iconfont icon-a-iconic_into3"></i>' : ''}
					</div>
				</div>
			`;
      $('.cart-bottom_wrapper .cart-discount-tip-wrapper').html(cartDiscountDom);
      // 上报
      var isLogin = LS.ui.isLogin();
			var cartDiscountTipDom = $('.cart-discount-module');
			var isMemberDiscountTip = cartDiscountTipDom.attr('data-discount-tip-type') == 1;
			var cartDiscountTipExt1 = '';
			if (isLogin) {
				if (isMemberDiscountTip) {
					cartDiscountTipExt1 = LS.ui.globalReportMap['showMemberDiscountTipsCart'];
				} else {
					cartDiscountTipExt1 = LS.ui.globalReportMap['showMarketDiscountTipsCart'];
				}
			} else {
				cartDiscountTipExt1 = LS.ui.globalReportMap['showJoinUsDiscountTipsCart'];
			}
			cartFn.cartReportHandle(LS.ui.reportType['moduleShow'], cartDiscountTipExt1, {ext5: $(".cart-discount-module_text").text()})
		},
   	/**
		 * 判断当前金额是否达到免邮门槛，返回免邮类型
		 * @param {*} total 匹配金额
		 * @returns
		 */
		handleHasShippingFree: function(total) {
      var standard = countryInfo.standard;
      var express = countryInfo.express;

      // 有快邮门槛且达到快邮门槛
      if (express !== standard && total >= express) {
        return 'Free Express Shipping';
      }
      // 达到平邮门槛
      if (total >= standard) {
        return 'Free Standard Shipping';
      }
      return '';
    },
    /**
		 * 判断该商品是否已存在购物车中
		 */
		isProductAlreadyExistsInCart: function() {
			if (!originCartItemList.length) return false;
			var lastProductId = LS.ui.getLastProductByAddCart();
			if (!lastProductId && LS.site.page === 'product') {
				lastProductId = $('#product-page-pc').attr('data-product-id') || '';
			}
			var cartProduct = originCartItemList.find(item => lastProductId !== '' && item.product_id == lastProductId);
			return cartProduct ? true : false;
		},
    appendProductDiscountHtml: function(dom) {
			if (!$('.add-product-tip-wrapper').length) return;
			if(dom) {
        $('.add-product-tip-wrapper').html(dom).show();

        var isLogin = LS.ui.isLogin();
				var productDiscountTipDom = $('.produc-discount-tip_wrapper');
				var isMemberDiscountTip = productDiscountTipDom.attr('data-discount-tip-type') == 1;
        var innerDiscountTipExt1 = '';
        if (isLogin) {
					if (isMemberDiscountTip) {
						innerDiscountTipExt1 = LS.ui.productReportMap['showMemberDiscountTipsByMember'];
					} else {
						innerDiscountTipExt1 = LS.ui.productReportMap['showMarketDiscountTipsByMember'];
					}
				} else {
					innerDiscountTipExt1 = LS.ui.productReportMap['showDiscountTipsByGuest'];
				}
        // 上报
        var params = {
          ext2: JSON.stringify(JSON.parse($('.stat-ext2').text())),
          ext3: $('.add-product-tip-wrapper').text()
        }
        LS.ui.globalModelShowHandle(document.querySelector('.add-product-tip-wrapper'), innerDiscountTipExt1, params);
			} else {
				cartFn.removeProductDiscountHtml();
			}
		},
    removeProductDiscountHtml: function() {
			$('.add-product-tip-wrapper').html('').hide();
		},
    getProductDiscountTipHtml: function(productDiscountOpts) {
			var moduleType = productDiscountOpts.moduleType || 2;
			var discountTipType = productDiscountOpts.discountTipType || 2;
			var discountAmountStr = productDiscountOpts.productDiscountAmountStr || '';
			var discountText = productDiscountOpts.discountText;
			var discountIcon = productDiscountOpts.discountIcon;
			var productDiscountTipHtml = `
				<div class="produc-discount-tip_wrapper ${discountTipType === 1 ? 'member-discount-tip-wrapper' : 'market-discount-tip-wrapper'} ${moduleType=== 1? 'produc-discount-tip_btn' : ''}" data-discount-tip-type="${discountTipType}">
					<div class="produc-discount-tip_left ${discountAmountStr ? 'large-bg' : 'small-bg' }">
						${moduleType !== 1 
								? `<img class="produc-discount-tip_left-icon" src="${discountIcon}" />` 
								: ''}
						<div class="produc-discount-tip_left-amount">${discountAmountStr}</div>
					</div>
					<div class="produc-discount-tip_right">
						<div class="produc-discount-tip_right-text">${discountText}</div>
						${moduleType !== 1 
							? ''
							: '<i class="produc-discount-tip_right-arrow-icon iconfont icon-a-iconic_into3"></i>'}
					</div>
				</div>
			`;
			return productDiscountTipHtml;
		},
		getDiscountTipIcon: function(couponMemberCategory) {
			var isLogin = LS.ui.isLogin();
			var icon = couponMemberCategory === 1 && isLogin ? LS.ui.getMemberIcon(LS.userVipInfo.userPointsInfo.currentVip) : 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_sale2_2x_53bb7384-69b7-44bd-9b27-37c79a64358c_72x.png?v=1673230973';
			return icon;
		},
    /**
		 * 计算添加商品后可享的折扣后插入到商详页
		 */
		insertProductDiscountModule: function() {
			if (!LS.ui.isFunctionOpenCountry()) return; 
			// 已存在移除凑单提示
			if (cartFn.isProductAlreadyExistsInCart()) {
				cartFn.removeProductDiscountHtml();
				return;
			};
			var marketAbtestResObj = LS.ui.getMarketAbtestResult && LS.ui.getMarketAbtestResult() || {};
			var isLogin = marketAbtestResObj.isLogin || LS.ui.isLogin() || false;
			if (LS.ui.showRegisteModule()) return;
      var isShowMarketModule = marketAbtestResObj.isShowModule || false;
			var curCartAmount = cartFn.getOriginCartAmount();
			var curProductPrice = $('#product-page').attr('data-current-price') / 100;
      var curProductType = $('#product-page').attr('data-product-type');
			var preBeddingDiscountAmount = 0;
			if (curProductType == 2) {
				preBeddingDiscountAmount = curProductPrice * 0.2
			}
			var preCartAmount = curCartAmount + curProductPrice;
			var discountInfo = '';
			var symbolCode = countryInfo.symbolCode + countryInfo.symbol;
			var targetItem = cartFn.filterBestCouponItem(preCartAmount, originCartNumber + 1, false, preBeddingDiscountAmount);
      var isBeddingCoupon = targetItem.isProductCoupon;
      if (isShowMarketModule) {
        // 获取加购该商品后可用的优惠券列表
        var preAvailableCouponList = cartFn.filterAvailableCouponList(preCartAmount, originCartNumber + 1, false);
        var reachedMaxDiscountInfo = cartFn.isReachedMaxDiscountInfo(targetItem);
        // var isReachedMaxDiscount = reachedMaxDiscountInfo.isReachedMaxDiscount;
        // var isShowDiscountTip = preAvailableCouponList.length && !isReachedMaxDiscount;
        var isShowDiscountTip = preAvailableCouponList.length;
        var productDiscountAmountStr = '';
        var discountIcon = '';
        var discountText = '';
        var productDiscountOpts = {};
        // 有可用券，且推荐的券不是已满足当前使用门槛的券  ----> 显示凑单满减后满足的门槛优惠券
        if (isShowDiscountTip && (!isBeddingCoupon || isBeddingCoupon && curProductType == 2)) {
          discountIcon = cartFn.getDiscountTipIcon(targetItem.couponMemberCategory);
          var discountPercentageStr = targetItem.discountPercentage;
          var discountAmountStr = discountPercentageStr ? symbolCode + discountPercentageStr : symbolCode + targetItem.discountAmount;
          var discountText = `Add this item to apply Code: <span>${targetItem.discountCode}</span>, get <span class="discount-sum">${discountAmountStr}</span> Off`;
          productDiscountOpts = {
            discountText: discountText,
            discountAmountStr: discountAmountStr,
            discountTipType: targetItem.couponMemberCategory, // 优惠券是否是会员券
            discountIcon: discountIcon
          };
          if (discountPercentageStr) {
            var discountPercentageNumber = Number(discountPercentageStr.replace('%', ''));
            productDiscountAmountStr = symbolCode + (curProductPrice * (1 - discountPercentageNumber / 100)).toFixed(2);
            productDiscountOpts.productDiscountAmountStr = productDiscountAmountStr;
          }				
          discountInfo = cartFn.getProductDiscountTipHtml(productDiscountOpts);
        } else {
          if (!isLogin) {
            productDiscountAmountStr = symbolCode + (curProductPrice * 0.9).toFixed(2);
            discountText = 'Join for an Exclusive 10% Off';
            productDiscountOpts = {
              productDiscountAmountStr: productDiscountAmountStr,
              discountText: discountText,
              moduleType: 1,
              discountTipType: 1
            };
            discountInfo = cartFn.getProductDiscountTipHtml(productDiscountOpts);
          }
        }
      }
			
			cartFn.appendProductDiscountHtml(discountInfo);
		},
    handleShowNewDiscount() {
			$("#cart-tip-popup").length && $("#cart-tip-popup").remove();
			var discountInfo = '';
      var targetItem = cartFn.filterBestCouponItem();
			if (targetItem) {
        discountInfo = `Best-offer code matched: ${LS.site.country + targetItem.currencyCode + targetItem.discountAmount } Off`
      }

			var curCartAmount = cartFn.getOriginCartAmount();
      if (!curCartAmount) return;
			var newCartAmount = discountInfo !== '' ? curCartAmount - targetItem.discountAmount : curCartAmount;
			var newShippingFreeText = cartFn.handleHasShippingFree(newCartAmount);
			var matchShippingFree = curShippingFreeText !== newShippingFreeText;
      if (matchShippingFree) {
				curShippingFreeText = newShippingFreeText;
				if (discountInfo !== '') {
					curShippingFreeText !== '' ? (discountInfo = discountInfo + ' & ' + curShippingFreeText) : discountInfo;
				} else {
					curShippingFreeText !== '' ? (discountInfo = `You've got <span>${ curShippingFreeText }</span>`) : ''
				}
			}

			if (discountInfo) {
        if (LS.site.page == 'cart') return;
				discountInfo += ' for your order.';
				var cartPos = $('.header-cart_pc')[0].getBoundingClientRect();
        $("#shopify-section-looksky-header").append(cartTipPopupHtml);
        $('#cart-tip-popup .cart-tip-popup_text').html(discountInfo);

        // 曝光上报
				LS.stat({
          eid: LS.ui.reportType['moduleShow'],
          ext1: LS.ui.productReportMap['showBagPopDiscountTipsProduct'],
          ext3: $('#cart-tip-popup .cart-tip-popup_text').text()
        });
        
        $("#cart-tip-popup").css({
          left: (cartPos.left + cartPos.width - 376) + 'px',
        })
        $('.cart-tip-popup_close').on('click', function() {
          $("#cart-tip-popup").hide();
          // 上报
          LS.stat({
            eid: LS.ui.reportType['click'],
            ext1: LS.ui.productReportMap['clickIcCloseBagPopDiscountTipsProduct'],
            ext3: $('#cart-tip-popup .cart-tip-popup_text').text()
          });
        })
			}
		},
    handleMatchDiscount: function(handleType) {
      $('.cart-discount-tip-wrapper').length && cartFn.recomNextDiscount();
      handleType === 1 && cartFn.handleShowNewDiscount();
		},

    /**
     * 根据abtest类型以及购物车数量，进行不同形态的展示的方法
     */
    cartCountAbtestHandle(count, type = '') {
      // ---------根据数量判断显示also love区域的营销文案---------
      var marketHtml;
			if (count == 0) {
				marketHtml =
					`<p class="ls-mark-text-abt">${ LS.$t('bag.buy_more_text1', '', 1) }</p>`;
			} else if (count == 1) {
				marketHtml =
				  `<p class="ls-mark-text-abt">${ LS.$t('bag.buy_more_text2', '', 1) }</p>`;
			} else if (count == 2) {
				marketHtml =
				  `<p class="ls-mark-text-abt">${ LS.$t('bag.buy_more_text3', '', 1) }</p>`;
			} else {
				marketHtml = '';
			}

      // ---------根据购物车数量触发顶部checkout弹窗提示--------
      if ( count >= 3  && LS.site.page != 'cart' && type == 2 ) {
        var marketCheckoutTipHtml = `
            <div class="ls-market-checkout-tipimg-abt">
              <img class="tipimg-abt" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ls_market_checkout-web.png?v=1656569336" />
            </div>
          `;
        // 在页面显示模块
        $(".header-modelcon-right").append(marketCheckoutTipHtml);
        // 延迟设置透明度变化效果
        setTimeout(function () {
          $(".header-modelcon-right")
            .find(".tipimg-abt")
            .attr("style", "opacity: 1");
        }, 100);
        // 10s后自动消失
        setTimeout(function () {
          $(".ls-market-checkout-tipimg-abt").remove();
        }, 10000);
        // 曝光上报
        LS.stat({
          eid: LS.ui.reportType['moduleShow'],
          ext1: LS.ui.reportMap['showSalePop']
        });
      }
    },
    checkoutPreload: function() {
			if (sessionStorage.getItem("checkoutPreload")) return;
			var ifr = `
			<iframe style="width: 1px; height: 1px; opacity: 1;" srcdoc='<!DOCTYPE html><html lang="en"><head>
				<meta charset="UTF-8">
				<meta http-equiv="X-UA-Compatible" content="IE=edge">
				<meta name="viewport" content="width=device-width, initial-scale=1.0">
				<title>checkout preload</title>

				<link rel="stylesheet" href="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/shopify-checkout-style.css?v=1659948245" media="all">
			</head>
			<body>
        <script src="//cdn.shopify.com/app/services/56828952624/javascripts/checkout_countries/123191066672/en-US/countries-c19ab71756a6251e21a59aa97d81ddd5b4659d14-c19ab71756a6251e21a59aa97d81ddd5b4659d14-0-d295b8ba1ab1e296ee2c6d377b1e79b7a1dddd34.js?version=2021-01-25" crossorigin="anonymous"></script>
        <script src="//cdn.shopify.com/shopifycloud/shopify/assets/checkout_2021-01-25-96667d41e7fe5fac4c6033f3d608cb762ee71e5ff16c88b8336bb65f48bcbd46.js" crossorigin="anonymous"></script>
        <script src="//cdn.shopify.com/shopifycloud/shopify/assets/shopify_pay-56e2abe72eaa64df4fb10c9b0f77888826c6d64b62f1ffb3fa8dc9839bb22b08.js" crossorigin="anonymous"></script>
				<script>
					sessionStorage.setItem("checkoutPreload", 1);
				</script>
			</body>
			</html>'></iframe>
		`;
			$('body').append(ifr.replace(/\n/g, ''));
		},
    insertCartBottomList: function() {
			var cartBottomDom = $('#ls-cart-collection').find('.ls-featured-collection-listing');
			var cartBottomCollectionId = cartBottomDom.attr('data-collection-id');
			LS.ui.collectionFn.getCollectionModule({
				dom: cartBottomDom, 
				collectionId: cartBottomCollectionId, 
				canLoadMore: true,
				reset: true,
				handleType: 2
			});
		},
    /**
     * 获取购物车列表，加载looksky-cart.liquid
     */
    request: function (firstLoad, addBagRequest) {
      try {
        LS.ajax({
          url: LS.ui.routes.getCartListUrl,
          dataType: "html",
          success: function (res) {
            LS.ui.handleMarketAbtest && LS.ui.handleMarketAbtest();
            var responseHTML =
              JSON.parse(res || "null")["looksky-cart-pc"] || "";
            var container = $(responseHTML).find("#cart-template").html() || "";
            cartBody.html(container);
            setTimeout(() => {
              firstLoad && LS.ui.setFirstView();
              firstLoad && LS.ui.setInteractive();
            }, 0);
            // 获取购物车信息，修改数量
            cartFn.getCartDataInfo(2, addBagRequest, '', firstLoad);
            // 获取购物车元数据信息并修改预售文案方法
            cartFn.getCartPreOrderDataHandle();
            cartFn.insertCartBottomList();
            // 购物车页滚动商品集合方法
            LS.ui.collectionFn.bindScrollType("cartPage");
            // 隐藏loading弹窗
            LS.ui.loadingPopHide();
						LS.ui.reporterCartState();
            setTimeout(function() {
							cartFn.checkoutPreload();
            }, 50)
            // 上报
            if (firstLoad) {
              cartFn.cartReportHandle(LS.ui.reportType['moduleShow'], LS.ui.reportMap['showBagPage'], {ext5: 'nav_icon'})
            }
          },
          error: function (e) {
            LS.ui.loadingPopHide();
          },
        });
      } catch (e) {
      }
    },

    /**
     * 获取购物车元数据信息并修改预售文案
     */
    getCartPreOrderDataHandle: function () {
      var cartList = $(".cart-item-list").find(".cart-item_container-box");
      // 遍历商品集合
      $.each(cartList, function (index, item) {
        if ($(item).find(".presell-tip").length > 0) {
          var cartItemMetafieldsInfo = $(item)
            .find(".presell-tip")
            .attr("value");
          var metafieldsData = JSON.parse(cartItemMetafieldsInfo);
          // 判断当前是否是预售商品
          if (
            metafieldsData.sellType == 4 ||
            (metafieldsData.sellType == 2 && metafieldsData.soldOutStatus == 1)
          ) {
            // 获取preorder预售文案方法
            LS.ui.productPopupFn.getProductPreOrderText(
              metafieldsData,
              $(item).find(".presell-tip")
            );
          }
        }
      });
    },

    /**
     * 购物车加减、input blur事件
     * @param {*} handleType
     * @param {*} cartId
     * @param {*} self
     */
    handleCalc: function (handleType, cartId, self) {
      var ret, $input;
      if (handleType === CHANGE_TYPE) {
        $input = $(self);
        ret = $input.attr("value");
      } else {
        $input = $(self).siblings(".quantity");
        var curVal = Number.parseInt($input.attr("value"));
        if (handleType === INCREASE_TYPE) {
          var canIncrease = Number.parseInt($(self).attr("data-can-increase"));
          var inventoryQuantity = $(self).attr("data-inventory-quantity");
          LS.ui.reporterSingle(
            LS.ui.reportMap["increaseCartItemQuantity"],
            self
          );
          // 不可增加，做提示
          if (!canIncrease) {
            LS.ui.toastShowHandle(
              LS.$t('bag.inventory_quantity_tip', { inventoryQuantity: inventoryQuantity })
            );
            return;
          }
          ret = curVal + 1;
        } else {
          ret = curVal - 1;
          LS.ui.reporterSingle(LS.ui.reportMap["minusCartItemQuantity"], self);
          if (ret < 1) {
            cartFn._delItem(cartId, self);
            return;
          }
        }
      }
      // 加载loading弹窗
      LS.ui.loadingPopShow();
      LS.ajax({
        url: LS.ui.routes.changeCarItemtUrl,
        type: "POST",
        data: {
          id: cartId,
          quantity: ret,
        },
        success: function () {
          cartFn.request(false, 1);
        },
        error: function (e) {
          LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    },
    calcFinalCartAmount: function(originAmount, discountAmount, pointAmount) {
			if (!originAmount) return 0;
			discountAmount = discountAmount || 0;
			pointAmount = pointAmount || 0;
			return originAmount - discountAmount - pointAmount;
		},
		calcExchangeablePoints: function(originAmount, discountAmount, availablePoints) {
			if (!originAmount) return 0;
			discountAmount = discountAmount || 0;
			availablePoints = availablePoints || 0;
			// 可抵扣的最高积分
      var allowExchangePoints = ((originAmount * 100 - discountAmount * 100) * pointRatio) / 100;
			var exchangeablePoint = 0;

			if (availablePoints === 0) {
				return {
					points: 0,
					amount: 0
				}
			} 
			
			// 可用积分小于可抵扣最高积分，可全部使用
			if (allowExchangePoints >= availablePoints) {
        exchangeablePoint = availablePoints;
				return {
					points: exchangeablePoint,
					amount: cartFn.getAmountByExchangePoints(exchangeablePoint)
				}
			}

			// 可用积分大于可抵扣最高积分，只部分使用
			if (allowExchangePoints < availablePoints) {
				exchangeablePoint = allowExchangePoints;
				return {
					points: exchangeablePoint,
					amount: cartFn.getAmountByExchangePoints(exchangeablePoint)
				}
			}
		},
    handleBeddingCartItems: function(coupon) {
			if (isOpenBeddingDiscount && isCartHasBedding) {
				var cartSellItemsDom = $('#on-sell-items').find('.cart-item_container-box');
				var cartSellItemsDomLen = cartSellItemsDom.length;
				var symbolCode = countryInfo.symbolCode + countryInfo.symbol;
				if (cartSellItemsDomLen) {
					for (var i = 0; i < cartSellItemsDomLen; i++) {
						var singleBeddingDiscount = 0;
						var cartSellItem = $(cartSellItemsDom[i]);
						var isKindBelong = LS.ui.isKindBelong ? LS.ui.isKindBelong(3, cartSellItem) : '';
						var isBedding = isKindBelong.bedding || false;
						if (isBedding) {
							var priceDom = cartSellItem.find('.price');
							var disountPriceDom = cartSellItem.find('.discount-price');
							var beddingDisountTipDom = cartSellItem.find('.bedding-code-price');
							var beddingPrice = priceDom.attr('data-price');
							var beddingComparePrice = priceDom.attr('data-compare-price');
              var beddingPriceStr = symbolCode + (beddingPrice / 100).toFixed(2);
              var beddingComparePriceStr = beddingComparePrice ? symbolCode + (beddingComparePrice / 100).toFixed(2) : '';
              if (coupon.isProductCoupon) {
                var beddingQuantity = cartSellItem.find('.quantity').attr('value');
                singleBeddingDiscount = beddingPrice * beddingQuantity * 0.2;
                var singleBeddingDiscountStr = symbolCode + (singleBeddingDiscount / 100).toFixed(2);
                var beddingDiscountPrice = beddingPrice - beddingPrice * 0.2;
                var beddingDiscountPriceStr = symbolCode + (beddingDiscountPrice / 100).toFixed(2)
                priceDom.text(beddingDiscountPriceStr);
                disountPriceDom.text(beddingPriceStr).show();
                beddingDisountTipDom.text(`(Bedding20, ${singleBeddingDiscountStr})`).show();
              } else {
                priceDom.text(beddingPriceStr);
                beddingComparePriceStr ? disountPriceDom.text(beddingComparePriceStr).show() : disountPriceDom.hide();
                beddingDisountTipDom.hide();
              }
						}
					}
				}
			}
		},
    // 购物车底部checkout区域abt方法
		cartBottomCheckoutModelHanlde: function () {
			var cartNum = Number.parseInt($('#cart-sum').text() || 0);
			var cartTotal = cartFn.getOriginCartAmount();
			var storeSelectedCoupon = JSON.parse(localStorage.getItem(storeCoupon) || 'null') || '';
			var selectedCouponItem = storeSelectedCoupon ? cartFn.getSingleDiscountInfo(storeSelectedCoupon) : '';
			var selectedCouponVailable = selectedCouponItem.vailable;
			var isSelectedCouponVailable = selectedCouponItem && selectedCouponVailable;
			var selectedCouponDiscountCode = selectedCouponItem.discountCode;
			var cartDiscountAmount = Number(selectedCouponItem.discountAmount);
			var cartDiscountTotal = cartTotal - cartDiscountAmount;
			var cartDiscountAmountDisplay = cartDiscountAmount.toFixed(2);
			var currencySymbol = `${countryInfo.symbolCode}${countryInfo.symbol}`;
			var selectedCouponDiscountPrice = `${currencySymbol}${isSelectedCouponVailable ? LS.i18n.fmtAmount(cartDiscountAmountDisplay) : '0.00'}`
			var compareAmount = isSelectedCouponVailable ? cartDiscountTotal : cartTotal;
      var shippingData = cartFn.getShippingData(compareAmount)
			var shippingTypeStr = shippingData.shippingType === 2 ? LS.$t('bag.express_text') : LS.$t('bag.standard_text');
			var shippingStatus = shippingData.shippingType;
			var subTotal = `${countryInfo.symbolCode}${countryInfo.symbol}${LS.i18n.fmtAmount(cartTotal.toFixed(2))}`;
			var exchangePointsInfo = cartFn.getExchangePointsInfo();
      var availablePoints = exchangePointsInfo.points;
      var availableGiftCartCode = exchangePointsInfo.code;
			var exchangePointsInfo = cartFn.calcExchangeablePoints(cartTotal, cartDiscountAmount, availablePoints);
			var exchangePoints = exchangePointsInfo.points;
      var exchangeAmount = exchangePointsInfo.amount;
			var amountByExchangePoints = exchangePoints > 0 ? LS.i18n.fmtAmount(exchangeAmount.toFixed(2)) : LS.i18n.fmtAmount('0.00');
			var amountByExchangePointsStr = '- ' + currencySymbol + amountByExchangePoints;
      var cartDetailInfo = {
				subTotal: subTotal,
				code: isSelectedCouponVailable ? selectedCouponDiscountCode : '',
				discountPrice: selectedCouponDiscountPrice,
        shippingType: shippingTypeStr,
				shippingStatus: shippingStatus,
				isLogin: LS.ui.isLogin(),
				exchangePoints: exchangePoints,
        exchangeCode: availableGiftCartCode,
				amountByExchangePointsStr: amountByExchangePointsStr,
				exchangePointsAmount: exchangeAmount
			};
			var freeMailInfo = {
				cartDiscountTotal: isSelectedCouponVailable ? cartDiscountTotal : cartTotal,
				standardPrice: Number(countryInfo.standard),
				expressPrice: Number(countryInfo.express),
				symbol: currencySymbol
			}
			var cartBottomPriceDetailHtmlStr = LS.tmpl(cartBottomPriceDetailModel, cartDetailInfo);
			var showSelectedCoupon = cartNum && storeSelectedCoupon && isSelectedCouponVailable;
      var finalCartAmount = cartFn.calcFinalCartAmount(cartTotal, cartDiscountAmount, exchangeAmount);
			cartFn.changeFinalCartTotalDisplay(finalCartAmount);

      // 添加礼品卡
			if (exchangePoints > 0) {
				cartFn.handleGiftCardInfoCart(availableGiftCartCode);
			}

			$("#btn-wrapper-pop-abt").html(cartBottomPriceDetailHtmlStr);

      if (showSelectedCoupon) {
			} else {
        $('#btn-wrapper-pop-abt .btn-wrapper-pop-list-code .poplist-value-price').attr('style', 'color: #b4aba0;');
				if (LS.site.page === 'cart' || $('#cart-drawer').css('display') === 'block') {
					localStorage.removeItem(storeCoupon);
					selectedCouponItem && selectedCouponDiscountCode && LS.ui.toastShowHandle(LS.$t('bag.code_invalid_toast', { code: selectedCouponDiscountCode }));
				}
				// 去除折扣应用, 重新判断是否有优惠券可使用
				cartFn.handleUseMaxDiscountCoupon();
			}

      cartFn.handleBeddingCartItems(storeSelectedCoupon);
			
			if (freeMailInfo.cartDiscountTotal > 0) { 
        var differenceHtmlStr = LS.tmpl(cartBottomFreeMailTipsModel, freeMailInfo);
        var shippingBoxDom = $(".cart-bottom_wrapper .shipping-box");
        shippingBoxDom.length && shippingBoxDom.html(differenceHtmlStr);

        var freeMailHtmlStr = LS.tmpl(cartBottomFreeMailTipsModelTwo, freeMailInfo);
        var freeMailBoxDom = $(".cart-bottom_wrapper .freemail-box");
        freeMailBoxDom.length && freeMailBoxDom.html(freeMailHtmlStr);
      }
			cartFn.cartTopModelHanlde(compareAmount);

			cartFn.cartReportHandle(LS.ui.reportType['moduleShow'], LS.ui.globalReportMap['showSubtotalPop'], {ext5: 'nav_icon'});
		},

		/**
		 * 购物车顶部提示区域方法
		 */
		cartTopModelHanlde: function (cartTotal) {
			if ( LS.cookie.get('graecove_token') && LS.userVipInfo && LS.userVipInfo.userCurrentVip) {
        var topLoginHtml = `
          <p class="p1">${ LS.$t('bag.order_get_points', { point: (cartTotal*LS.site.rate*LS.userVipInfo.userCurrentVip.consumeRewardPoints).toFixed(0) }, 1) }</p>
        `;
        $(".cart-user-point-shipping .tip-box").html(topLoginHtml);
			} else {
        var isShowMarketingTip = true;
				if (isShowMarketingTip) {
					$(".cart-user-point-shipping .tip-box").show();
					$(".cart-user-point-shipping .tip-box").html(
            `	
            <div class="tip-box-inner">
              <p class="tip-box-item p1">· Buy <span class="sp1">2</span> Get 20% Off, Code: <span class="sp1">SA20</span></p>
              <p class="tip-box-item p1">· Buy <span class="sp1">3</span> Get 25% Off, Code: <span class="sp1">SA25</span></p>
              <p class="tip-box-item p1">· Buy <span class="sp1">4</span> Get 30% Off, Code: <span class="sp1">SA30</span></p>
          </div>
            `);
				} else {
					$(".cart-user-point-shipping .tip-box").remove();
				}
			}
		},
    handleUseMaxDiscountCoupon: function() {
			var bestCoupon = cartFn.filterBestCouponItem();
			if (bestCoupon) {
				localStorage.setItem(storeCoupon, JSON.stringify(bestCoupon));
				confirmUseCoupon = bestCoupon;
			} else {
				localStorage.removeItem(storeCoupon);
			}
		},
    handleCouponMaxDiscount: async function(type =1) {
			if (type == 1) {
        cartFn.handleUseMaxDiscountCoupon();
			} else {
        await cartFn.getCartCouponList();
				// 筛选
				confirmUseCoupon = (userAvailableCouponList.filter(item => item.discountCode == confirmUseRedeemCode))[0];
				// 定义处理数据
				var params = {
					availableCouponList: userAvailableCouponList,
					confirmUseCoupon: confirmUseCoupon,
				};
				// 更换可用优惠券集合
				var htmlStr = LS.tmpl(couponEditPopListHtml, params);
				// 添加弹窗
				$('.ls-main-popupbox-coupon-edit .available-coupon-list').html(htmlStr);
			}
		},
		/**
		 * 获取优惠券信息
		 */
     getCartCouponList: function () {
			return new Promise(function(resolve, reject) {
				if (LS.cookie.get('graecove_token')) {
					// 调用接口
					LS.ajax({
						url: LS.ui.routes.queryUserCouponsApi,
						type: "GET",
						data: {
							lastId: '',
							count: 100,
							userCouponType: 1,
						},
						success: function (res) {
							if (!res.hasError && res.code == '0' && res.data && res.data.record && res.data.record.length > 0) {
                userCouponList = res.data.record.concat(LS.ui.normalCouponList.slice());
                cartFn.filterAvailableCouponList();
                resolve();
							} else {
                userCouponList = LS.ui.normalCouponList.slice();
                cartFn.filterAvailableCouponList();
								// 报错
                resolve();
							}
						},
						error: function (error) {
              userCouponList = LS.ui.normalCouponList.slice();
							cartFn.filterAvailableCouponList();
              // reject();
              resolve();
						},
					});
				} else {
          userCouponList = LS.ui.normalCouponList.slice();
					cartFn.filterAvailableCouponList();
					resolve();
				}
			});
		},
    insertCouponRedeemList: function(pointsCouponRedeemList, userPointsInfo) {
			pointsCouponRedeemList = pointsCouponRedeemList.map(item => {
				return {
					...item,
          vailable: item.redeemPointsAmount <= userPointsInfo.availablePoints,
          userCouponType: userPointsInfo.availablePoints >= item.redeemPointsAmount ? 1 : 2,
				}
			})
			var redeemCouponListDom = LS.ui.renderCouponListHtml({
				arr: pointsCouponRedeemList, 
				className: 'cart-redeem_coupon-box',
				type: 3
			});
			$('.ls-main-popupbox-coupon-edit .redeem-coupon-list').html(redeemCouponListDom);
		},
		/**
		 * 获取用户积分会员信息方法
		 */
		getUserVipPointInfoHandle: function () {
      // 判断登录态
			if ( !LS.cookie.get('graecove_token')) {
        return;
			}
			// 调用接口
			LS.ajax({
				url: LS.ui.routes.queryUserPointsInfoApi,
				type: "GET",
				success: function (res) {
					if (!res.hasError && res.code == '0' && res.data.userPointsInfo) {
            var userPointsInfo = res.data.userPointsInfo;
						var pointsCouponRedeemList = res.data && res.data.pointsCouponRedeemSettingsList ? res.data.pointsCouponRedeemSettingsList : [];
						if (pointsCouponRedeemList.length) {
							cartFn.insertCouponRedeemList(pointsCouponRedeemList, userPointsInfo);
						}
						// 会员中心信息
						LS.userVipInfo = res.data;
					} else {
						res.error && LS.ui.toastShowHandle(res.error.message);
					}
				},
				error: function (error) {
				},
			});
		},
    handleGiftCardInfoCart: function(code) {
      code ? $('#cart-gift-card').attr('value', code) : $('#cart-gift-card').attr('value', '');
      // 储存giftcard,用于判断取消使用giftcard时,去checkout里面手动去选之前使用的card
			code && localStorage.setItem('graecove_cart_giftcard', code);
		},
    handleSelectUsePoint: function(pointSelector) {
			var pointCheckboxDom = $(pointSelector).find('.cart-details_points-checkbox');
			var cartTotalDom = $('.btn-wrapper-abt').find('#cart-total');
			var pointsAmount = Number($('#cart-points-amount').attr('data-exchange-points-amount'));
      var giftCardCode = $('#cart-points-amount').attr('data-code');
      var finalCartAmount = Number(cartTotalDom.attr('data-findal-cart-amount'));
			var pointsCheckedClassName = 'icon-points-checked';
			if (pointsAmount <= 0) return;
			if (pointCheckboxDom.hasClass(pointsCheckedClassName)) {
				pointCheckboxDom.removeClass(pointsCheckedClassName);
				finalCartAmount = finalCartAmount + pointsAmount;
        cartFn.handleGiftCardInfoCart();
			} else {
				pointCheckboxDom.addClass(pointsCheckedClassName);
				finalCartAmount = finalCartAmount - pointsAmount;
        cartFn.handleGiftCardInfoCart(giftCardCode);
			}
			cartFn.changeFinalCartTotalDisplay(finalCartAmount);
		},
		changeFinalCartTotalDisplay: function(finalCartAmount) {
			var siteSymbol = LS.site.symbol;
			var finalCartAmountStr = `${siteSymbol}${LS.i18n.fmtAmount(finalCartAmount.toFixed(2))}`;
			var cartTotalDom = $('.btn-wrapper-abt').find('#cart-total');
			cartTotalDom.text(finalCartAmountStr);
			cartTotalDom.attr('data-findal-cart-amount', finalCartAmount);
      cartFn.handleGiftModuel(finalCartAmount);
		},
    handleGiftModuel: function(finalCartAmount) {
      var isInsertGiftModule = false;
      if (!isInsertGiftModule || !LS.ui.isFunctionOpenCountry()) return;
			if (finalCartAmount < 149) return;
			LS.ajax({
				url: LS.ui.routes.getGiftStock,
				type: 'GET',
				success: function (res) {
					if (res.hasError || res.code !== '0') return;
					var data = res.data || [];
					var giftItem = data.length ? data[0] : {};
					var hasStock = false;
					var giftWrapper = $('#gift-wrapper');
					if (giftItem) {
						var giftVariantList = giftItem.variantList.filter(item => giftSkuList.includes(item.sku));
						var giftVariantListLen = giftItem.variantList.length;
						for (var i = 0; i < giftVariantListLen; i++) {
							var giftVariant = giftVariantList[i];
							if (giftVariant.stockQuantityFromSupplyChain - giftVariant.waitingQuantityFromSupplyChain > 0) {
								hasStock = true;
								break;
							}
						}
						if (hasStock) {
							var hasGiftDiffAmount = 219 - finalCartAmount;
							if (hasGiftDiffAmount > 0) {
								giftItem.hasGiftDiffAmount = hasGiftDiffAmount.toFixed(2);
							}
							var giftModuleHtmlStr = LS.tmpl(giftModuleHtml, giftItem);
							giftWrapper.show().append(giftModuleHtmlStr);
							curGiftVariantList = giftVariantList;
						}
					}
				},
				error: function (e) {
				},
			});
		},
    handleSubmitGiftColor: function() {
			var activeGiftVariant = $('.gift-color-selector_color-item.active');
			if (!activeGiftVariant.length) return LS.ui.toastShowHandle('Please choose');
			// var targetVariantId = activeGiftVariant.attr('data-variant-id');
			var targetVariantSku = activeGiftVariant.attr('data-sku');
			var targetVariantImg = activeGiftVariant.attr('data-img');
			var targetVariantColor = targetVariantSku ? targetVariantSku.split('-')[1] : '';
			var giftItemDom = $('.gift-item');
			giftItemDom.find('.gift-item_product-img').attr('src', targetVariantImg);
			giftItemDom.find('.gift-item_product-selected-color').text(targetVariantColor);
			giftItemDom.attr('data-selected-sku', targetVariantSku);
			giftItemDom.addClass('active').siblings('.gift-selector').removeClass('active');
			$('#cart-gift-sku').attr('value', targetVariantSku);
      $('#gift-color-selector').text(targetVariantColor);
      $('.popupbox_gift-color-selector').remove();
		},
		showGiftColorPopup: function() {
      var popupDom = $('.popupbox_gift-color-selector');
			if (popupDom.length) {
				popupDom.show();
			} else {
				var giftColorSelectorTmpl = LS.tmpl(giftColorSelectorDom, curGiftVariantList);
				var popupStr = LS.ui.createPopup('gift-color-selector', giftColorSelectorTmpl);
				$('body').append(popupStr);
			}	
		},
    /**
     * 事件集合
     */
    bindEvent: function () {
      $(document).on('click', '.gift-rule-btn', function() {
        LS.ui.renderSideDrawer(giftRulesDom);
			});

      $(document).on('click', '.popupbox-container_gift-color-selector .gift-color-selector_color-item', function() {
				var $this = $(this);
				var activeCls = 'active';
				$this.addClass(activeCls).siblings().removeClass(activeCls);
        var targetVariantSku = $this.attr('data-sku');
        var targetVariantColor = targetVariantSku ? targetVariantSku.split('-')[1] : '';
        $('#gift-color-selector').text(targetVariantColor);
			});

			$(document).on('click', '.gift-color-selector-submit-btn', function() {
        cartFn.handleSubmitGiftColor();
			});

			$(document).on('click', '.gift-wrapper .gift-item_product-color-wrapper', function() {
				var giftSelector = $(this).parents('.gift-selector');
				var hasGiftDiffAmount = giftSelector.attr('data-has-diff-amount');
				if (hasGiftDiffAmount) {
					hasGiftDiffAmount = countryInfo.symbol + hasGiftDiffAmount;
					LS.ui.toastShowHandle(`Not enough $219, just ${hasGiftDiffAmount} away from a free pillowcase. Keep shopping!`);
					return;
				}
        cartFn.showGiftColorPopup();
			});

			$(document).on('click', '.gift-wrapper .gift-selector', function() {
				var $this = $(this);
				var hasGiftDiffAmount = $this.attr('data-has-diff-amount');
				var handleType = $this.attr('data-type');
				var activeCls = 'active';
				if (hasGiftDiffAmount) {
					hasGiftDiffAmount = countryInfo.symbol + hasGiftDiffAmount;
					LS.ui.toastShowHandle(`Not enough $219, just ${hasGiftDiffAmount} away from a free pillowcase. Keep shopping!`);
					return;
				}
				if (handleType == 1) {
					var selectedSku = $this.attr('data-selected-sku');
					if (!selectedSku) { 
						cartFn.showGiftColorPopup();
						LS.ui.toastShowHandle('Please choose color');
						return;
					};
          $('#cart-gift-sku').attr('value', selectedSku);
				} else {
          $('#cart-gift-sku').attr('value', 'No need for a free gift');
        }

				$this.addClass(activeCls).siblings('.gift-selector').removeClass(activeCls);
			});

      // 加购按钮优惠提示推出
			$(document).on('click', '.add-product-tip-wrapper .produc-discount-tip_btn .produc-discount-tip_right', function() {
        LS.ui.dynamicInsertModuleFn.createSubscribePopupAbt(0, true, 1, '0', 'showJoinCollectivePopClcDiscountTipsProduct');
        // 商品详情页上报方法
				productReportMethod();
        sessionStorage.setItem('login_register_source', LS.ui.loginRegisterSourceFieldsMap['product_guide']);
			});
			
			// 商品详情页底部加购物车优惠提示推出
			$(document).on('click', '.product-detail_bottom-wrapper .produc-discount-tip_btn .produc-discount-tip_right', function() {
        LS.ui.dynamicInsertModuleFn.createSubscribePopupAbt(0, true, 1, '0', 'showJoinCollectivePopClcBottomDiscountTipsProduct');
        // 商品详情页上报方法
				productReportMethod();
        sessionStorage.setItem('login_register_source', LS.ui.loginRegisterSourceFieldsMap['product_guide']);
			});

			// 购物车优惠提示推出
			$(document).on('click', '.cart-discount-module_register-btn', function() {
				LS.ui.dynamicInsertModuleFn.createSubscribePopupAbt(0, true, 1, '0', 'showJoinCollectivePopClcDiscoutTipsBag');
        sessionStorage.setItem('login_register_source', LS.ui.loginRegisterSourceFieldsMap['cart_guide']);
      });

      // 商品详情页上报方法
			function productReportMethod() {
				if (LS.site.page === 'product') {
          var ext1 = LS.ui.userSubscriptionReportMap['clickJoinUsDiscountTip'];
          var  ext2 = $('.stat-ext2').text() ? JSON.stringify(JSON.parse($('.stat-ext2').text())) : '';
          LS.stat({
            eid: LS.ui.reportType['click'],
            ext1: ext1,
            ext2: ext2
          });
        }
			}

      $(document).on('click', '#cart-points-selector', function() {
				cartFn.handleSelectUsePoint(this);
			});

      // 点击创建编辑优惠券弹窗
			$(document).on("click", "#cart-edit-coupon-btn", function () {
				var availableCouponList = cartFn.filterAvailableCouponList();
				var notAvailableCouponList = cartFn.filterAvailableCouponList('', '', false, false);
				// 积分兑换优惠券列表
				// var pointsCouponRedeemList = LS.userVipInfo && LS.userVipInfo.pointsCouponRedeemSettingsList ? LS.userVipInfo.pointsCouponRedeemSettingsList : [];
				// var userPointsInfo = LS.userVipInfo && LS.userVipInfo.userPointsInfo ? LS.userVipInfo.userPointsInfo : {};
        $('.ls-main-popupbox-coupon-edit').remove();
				$('body').append(couponListPopupHtml);
        if (availableCouponList.length) {
          availableCouponList = availableCouponList.sort(function(a, b) {
						return b.discountAmount - a.discountAmount
					})
					var availableCouponListDom = LS.ui.renderCouponListHtml({
						arr: availableCouponList, 
						className: 'cart-available_coupon-box',
						type: 2,
						checkedCoupon: confirmUseCoupon
					});
					$('.ls-main-popupbox-coupon-edit .available-coupon-list').html(availableCouponListDom);
				} else {
					$('.ls-main-popupbox-coupon-edit .available-coupon-list').html(`
					<div class="no-coupon-status">
								<img class="empty-cover" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/empty_cart_cover.png?v=1649647528" width="170" height="170" loading="lazy">
								<p class="empty-text">No coupons here.</p>
							</div>
					`);
				}

				if (notAvailableCouponList.length) {
					var notAvailableCouponListDom = LS.ui.renderCouponListHtml({
						arr: notAvailableCouponList, 
						className: 'cart-not-available_coupon-box'
					});
					var notAvailableCouponModuleDom = `
						<p class="noavailable-title">${ LS.$t('bag.unavailable_coupons') }</p>
						<div class="con-coupon-list noavailable-coupon-list">${notAvailableCouponListDom}</div>
						<div class="noavailable-tip-box">
							<img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-coupon-tip-icon.png?v=1658302010" />
							<p class="p1">${ LS.$t('bag.code_no_conformance_toast') }</p>
						</div>
					`
					$('.ls-main-popupbox-coupon-edit .not-available-coupon-module').html(notAvailableCouponModuleDom);
				}

        setTimeout(function() {
					LS.ui.renderCountDownTimer('.ls-pop-coupon-edit-con');
				}, 300)
        
        // 禁止弹窗底部滚动方法
        LS.ui.popupNoScrollHandle();

        // 上报
        cartFn.cartReportHandle(LS.ui.reportType['click'], LS.ui.reportMap['clickCouponsListOpen']);
        cartFn.cartReportHandle(LS.ui.reportType['moduleShow'], LS.ui.reportMap['showCouponsListPop']);

      })

      // 输入框输入校验
			$(document).on('input', '.enter-coupon-code-model .coupon-code-inp', function(e) {
				// 获取code
				var domInp = $('.enter-coupon-code-model .coupon-code-inp');
				var domBtn = $('.enter-coupon-code-model .exchange-coupon-code-btn');
				var codeInp = $(domInp).val();
				if (codeInp) {
					$(domBtn).addClass('exchange-btn-active');
				} else {
					$(domBtn).removeClass('exchange-btn-active');
				}
			});
      
      // 点击兑换code
			var firstStatus = true;
			$(document).on("click", "#exchange-coupon-code-btn", function () {
				// 获取code
				var codeInp = $('.enter-coupon-code-model .coupon-code-inp').val();
				if (!codeInp) {
					LS.ui.toastShowHandle('Please enter your coupon code');
					return;
				}
				// 判断
				if (!firstStatus) {
          return;
				}
				firstStatus = false;
				// 加载动画
				var oldDom = $('#exchange-coupon-code-btn').html();
				LS.ui.loadingBtnShow($('#exchange-coupon-code-btn'), 2);
				// 接口
				LS.ajax({
					url: LS.ui.routes.checkAndReceiveDiscountCode,
					type: "GET",
					data: {
						discountCode: codeInp,
					},
					success: function (res) {
						if (!res.hasError && res.code == '0' && res.data) {
							// 成功
							$('.enter-coupon-code-model .coupon-code-box').removeClass('coupon-code-box-error');
							$('.enter-coupon-code-model .code-error-tip').text('');
							$('.enter-coupon-code-model .coupon-code-inp').val('');
							$('.enter-coupon-code-model .exchange-coupon-code-btn').removeClass('exchange-btn-active');
							// 隐藏动画
							LS.ui.loadingBtnHide($('#exchange-coupon-code-btn'), oldDom);
							// 把兑换的券加入优惠券数组
							LS.ui.isLogin() && userCouponList.push(res.data);
							// 处理数据
							var couponInfo = cartFn.getSingleDiscountInfo(res.data);
							// 判断领取的优惠券是否能使用
							if (couponInfo.vailable) {
								// 赋值
								confirmUseCoupon = res.data;
								userAvailableCouponList.push(res.data);
							}
							// 插入已兑换的优惠券
							var couponItemDom = LS.ui.renderCouponItem({
								couponItem: couponInfo, 
								couponIndex: 100, 
								couponType: couponInfo.vailable ? 2 : 1,
								checkedCoupon: confirmUseCoupon,
								needCopyBtn: false,
							});
							var couponDom = `<div class="get-coupon-box available-coupon-list">${couponItemDom}</div>`;
							if ( $('.enter-coupon-code-model .get-coupon-box').length ) {
								$('.enter-coupon-code-model .get-coupon-box').html(couponItemDom)
							} else {
								$('.enter-coupon-code-model').append(couponDom);
							}
							// 去选其他选中的优惠券
							if (couponInfo.vailable) {
								$('.ls-pop-coupon-edit .cart-available_coupon-box .coupon-checkbox').removeClass('icon-coupon-checked');
							} else {
								$('.enter-coupon-code-model .get-coupon-box').append(`<p class="code-error-tip" style="margin-top: 6px;padding-left: 0px;">Your current account or order status does not meet the coupon usage conditions.</p>`)
							}
							// 券倒计时处理
							setTimeout(function() {
								LS.ui.renderCountDownTimer('.ls-pop-coupon-edit-con');
              }, 300)
              // 赋值
							firstStatus = true;
						} else {
							// 失败
							$('.enter-coupon-code-model .coupon-code-box').addClass('coupon-code-box-error');
							$('.enter-coupon-code-model .code-error-tip').text(res.error.message);
							// 赋值
							firstStatus = true;
							// 隐藏动画
              LS.ui.loadingBtnHide($('#exchange-coupon-code-btn'), oldDom);
              // 判断券是否已经存在，存在就选中
							if (res.error.code === 'T10056') {
                $(`.available-coupon-list .coupon-checkbox[code=${codeInp}]`).click();
							}
						}
					},
					error: function (error) {
						// 失败
						$('.enter-coupon-code-model .coupon-code-box').addClass('coupon-code-box-error');
						$('.enter-coupon-code-model .code-error-tip').text('Something wrong, please try again later.');
						// 赋值
						firstStatus = true;
						// 隐藏动画
						LS.ui.loadingBtnHide($('#exchange-coupon-code-btn'), oldDom);
					},
				});
			})

			// 点击选中要使用的优惠券confirmUseCoupon
			$(document).on("click", ".available-coupon-list .coupon-item", function () {
        var targetIcon = $(this).find('.coupon-checkbox');
        var code = $(targetIcon).attr('code');
				if ( $(targetIcon).hasClass('icon-coupon-checked') ) {
					confirmUseCoupon = '';
					$(targetIcon).removeClass('icon-coupon-checked');
				} else {
					var checkedCoupon = userAvailableCouponList.find(item => item.discountCode == code);
					if ( checkedCoupon ) {
						confirmUseCoupon = checkedCoupon;
					}
					$('.available-coupon-list .coupon-checkbox').removeClass('icon-coupon-checked');
					$(targetIcon).addClass('icon-coupon-checked');
				}
			})

			// 点击用积分兑换优惠券
			$(document).on("click", ".ls-main-popupbox-coupon-edit .ls-coupon-redeem-btn", function () {
				// couponid
				var couponId = $(this).attr('couponid');
				// 筛选
				var newList = LS.userVipInfo && LS.userVipInfo.pointsCouponRedeemSettingsList.filter(item => item.pointsCouponRedeemSettingsId == couponId);
				// 创建页面内容
				var htmlStr = LS.tmpl(redeemPopHtml, newList[0]);
				// 添加弹窗
        $('body').append(htmlStr);
			})

			// 弹窗-点击兑换优惠券
			var exchangeStatus = false;
      $(document).on("click", ".ls-vertical-popupbox-redeempop .redeem-confirm-btn", function () {
				// 防止多次兑换
        if (exchangeStatus) {
          return;
        }
        exchangeStatus = true;
        // 获取id
        var couponId = $(this).attr('redeemId');
        // 调用接口
        LS.ajax({
          url: LS.ui.routes.redeemDiscountCodeApi,
          type: "POST",
          headers: {
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({
            pointsCouponRedeemSettingsId: couponId
          }),
          success: function (res) {
            if (!res.hasError && res.code == '0' && res.data) {
							// 重新获取可用优惠券列表
							cartFn.handleCouponMaxDiscount(2);
							// 重新获取积分模块
							cartFn.getUserVipPointInfoHandle();
							// 赋值
							confirmUseRedeemCode = res.data.discountCode;
							// 清除弹窗
              $('.ls-vertical-popupbox-redeempop').remove();
              // 恢复弹窗底部滚动方法
              LS.ui.popupRecoveryScrollHandle();
              // 上报
              LS.stat({
                eid: LS.ui.reportType['click'],
                ext1: LS.ui.accountReportMap['clickRedeem'],
                ext2: res.data.discountCode,
                ext3: $(this).attr('amount'),
                ext4: LS.userVipInfo && LS.userVipInfo.userBasicInfo && LS.userVipInfo.userBasicInfo.email ? LS.userVipInfo.userBasicInfo.email : '',
              });
            } else {
              res.error && LS.ui.toastShowHandle(res.error.message);
            }
            exchangeStatus = false;
          },
          error: function (error) {
            LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
            exchangeStatus = false;
          },
        });
			})

			// 点击查看优惠券规则
      $(document).on('click','.ls-pop-coupon-edit .coupon-li .p-row-btn',function(){
        // 如果原来已经选中，则取消
        if ( $(this).hasClass('active') ) {
          // 图片
          $(this).removeClass("active");
          // 规则
          $(this).parents('.coupon-li').find('.coupon-li-rule').removeClass("coupon-li-rule-active");
        } else {
          // 添加选中样式
          $(this).addClass("active");
          // 规则
          $(this).parents('.coupon-li').find('.coupon-li-rule').addClass("coupon-li-rule-active");
        }
      });

			// 点击优惠券弹窗confirm确认
			$(document).on("click", ".cart-coupon-pop-confirmbtn", function () {
				if (confirmUseCoupon) {
					// 储存
					localStorage.setItem(storeCoupon, JSON.stringify(confirmUseCoupon));
				} else {
					// 清除
				  localStorage.removeItem(storeCoupon);
				}
				// 调用底部checkout区域方法
				cartFn.cartBottomCheckoutModelHanlde();
        $('.cart-discount-tip-wrapper').length && cartFn.recomNextDiscount(true);
				// 删除弹窗
        $('.ls-main-popupbox-coupon-edit').remove();
        // 恢复弹窗底部滚动方法
        LS.ui.popupRecoveryScrollHandle();
        // 上报
				cartFn.cartReportHandle(LS.ui.reportType['click'], LS.ui.reportMap['clickBtnCocnfirm']);
			})

			// 点击dont want不使用任何优惠券
			// $(document).on("click", ".cart-coupon-pop-nousebtn", function () {
			// 	// 清除
      //   localStorage.removeItem(storeCoupon);
      //   // 赋空
			// 	confirmUseCoupon = '';
			// 	// 调用底部checkout区域方法
			// 	cartFn.cartBottomCheckoutModelHanlde();
			// 	// 删除弹窗
      //   $('.ls-main-popupbox-coupon-edit').remove();
      //   // 恢复弹窗底部滚动方法
      //   LS.ui.popupRecoveryScrollHandle();
      //   // 上报
			// 	cartFn.cartReportHandle(LS.ui.reportType['click'], LS.ui.reportMap['clickCancelUse']);
      // })
      
      // 优惠券弹窗关闭
			$(document).on("click", ".ls-main-popupbox-coupon-edit .ls-main-popupbox-overlay,.ls-main-popupbox-coupon-edit .title-close", function () {
				// 类型
				var type = $(this).attr('type');
				// 上报
				cartFn.cartReportHandle(LS.ui.reportType['click'], type === 1 ? LS.ui.reportMap['clickBlankCouponsListPop'] : LS.ui.reportMap['clickIcCloseCouponsListPop']);
			})

      // 点击顶部营销文案弹窗，跳转购物车页
      $(document).on("click", ".ls-market-checkout-tipimg-abt", function () {
        // 取消营销tip弹窗
        $('.ls-market-checkout-tipimg-abt').remove();
        // 跳转到购物车页
        window.location.href = `${LS.site.dir}/cart?scene=sale_pop`;
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.reportMap['clickGoCheckout']
        });
      });

      var classNameArr = [".minus-btn", ".increase-btn", ".quantity"];
      classNameArr.forEach((className) => {
        _$on(className);
      });

      function _$on(className) {
        var handle = className === ".quantity" ? "blur" : "click";
        $(document).on(handle, className, function () {
          var cartId = $(this).attr("data-id");
          var type = _getCalcMethod(className);
          cartFn.handleCalc(type, cartId, this);
        });
      }

      function _getCalcMethod(className) {
        var res = "";
        switch (className) {
          case classNameArr[0]:
            res = MINUS_TYPE;
            break;
          case classNameArr[1]:
            res = INCREASE_TYPE;
            break;
          case classNameArr[2]:
            res = CHANGE_TYPE;
            break;
        }
        return res;
      }

      // 复制优惠券code
      $(document).on("click", "#coupon-copy-btn", function () {
        // 复制方法
        var text = $(this).attr("data-clipboard-text");
        LS.ui.copyToClip(text);
        // 上报
				LS.ui.reporterMuti(
					4,
					`${LS.ui.reportMap['couponCode']}.${text}`,
					LS.ui.reportType["click"],
				);
      });

      // 确认
      $(document).on("click", "#submit-btn", function (e) {
        // 添加按钮load方法
        LS.ui.loadingBtnShow($('#submit-btn'), 1);
        cartFn.handleSubmit();
        // 储存的折扣使用信息
        var getCodeInfo = JSON.parse(localStorage.getItem(storeCoupon) || "null") || {};
        LS.ui.setCheckoutSource(this);
        // 获取来源
        var checkoutReportFrom = LS.getParam("scene");
        LS.ui.reporterMuti(
          1,
          LS.ui.reportMap["cartCheckout"],
          LS.ui.reportType["click"],
          getCodeInfo ? getCodeInfo.code : '',
          checkoutReportFrom
        );
				LS.ui.bingFn.eventReport && LS.ui.bingFn.eventReport('begin_checkout', $('#cart-total').attr('value'));
      });

      $(document).on("click", "#cart-klarna", function (e) {
        // 添加按钮load方法
        LS.ui.loadingBtnShow($('#cart-klarna'), 1);
        cartFn.handleSubmit();
        // 储存的折扣使用信息
        var getCodeInfo = JSON.parse(localStorage.getItem(storeCoupon) || "null") || {};
        LS.ui.setCheckoutSource(this);
        // 获取来源
        var checkoutReportFrom = LS.getParam("scene");
        LS.ui.reporterMuti(
          1,
          LS.ui.reportMap["cartCheckout"],
          LS.ui.reportType["click"],
          getCodeInfo ? getCodeInfo.code : '',
          checkoutReportFrom
        );
      });

      // 取消
      $(document).on("click", "#del-all", function () {
        var slot = cartFn.renderSoldoutSlot();
        LS.ui.renderBottomDrawer(
          {
            title: LS.$t('bag.sold_out_title', '', 1),
            slot,
          },
          "delAll"
        );
      });

      $(document).on("click", "#confirm-delete-all-soldout", function () {
        var soldoutIdsObj =
          JSON.parse($(this).attr("data-soldout") || "null") || {};
        LS.ajax({
          url: LS.ui.routes.updateCartItemUrl,
          type: "POST",
          data: {
            updates: soldoutIdsObj,
          },
          success: function () {
            $("#bottom-drawer").hide();
            cartFn.request();
            LS.ui.reporterMuti(
              2,
              LS.ui.reportMap["delAllSoldout"],
              LS.ui.reportType["click"]
            );
          },
          error: function (e) {
            LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
          },
        });
      });

      $(document).on("click", "#check-submit", function () {
				cartFn.updateCart(cartObj);
        LS.stat({
          eid: LS.ui.reportType["click"],
          ext1: LS.ui.reportMap["confirmCheckoutSoldout"],
        });
      });

      $(document).on("click", ".del-btn", function () {
        var cartId = $(this).attr("data-id");
        cartFn._delItem(cartId, this);
      });

      $(document).on("click", ".cart_choose-size_arrow-btn", function () {
        var productInfo =
          JSON.parse(
            $(this).find(".js-product-json_arrow-btn").text() || "null"
          ) || {};
        // 调用创建弹窗方法
        var productInfoData =
          LS.ui.collectionFn.processingProductData(productInfo);
        productInfoData.cartVariantList = cartFn.getCartVariantList();
        LS.ui.productPopupFn.lsCreatePopupHandle({
          data: productInfoData,
          dataDom: this,
          handle: 2,
          productBasicSource: 3
        });
        LS.ui.reporterSingle(LS.ui.reportMap["changeSku"], this);
      });

      $(document).on("click", ".cart-image, .cart-info_title", function () {
        LS.ui.reporterSingle(LS.ui.reportMap["visitProductDetails"], this);
      });
    },
    getCartVariantList: function() {
			var onSellItems = $('#on-sell-items').find('.cart-item_container-box');
			var arr = [];
			for (var i = 0, len = onSellItems.length; i < len; i++) {
				var targetCartitem = $(onSellItems[i]);
				var cartVariantId = targetCartitem.attr('data-variant-id');
				var cartVariantQuantity = targetCartitem.attr('data-quantity');
				if (cartVariantId && cartVariantQuantity > 0) {
					var variantObj = {
						variantId: cartVariantId,
						quantity: cartVariantQuantity
					}
					arr.push(variantObj);
				}
			}
			return arr;
		},
    _delItem: function (cartId, self) {
      LS.ui.genDialogConfirm({
        text: LS.$t('bag.pop_title', '', 1),
        confirmBtnText: LS.$t('bag.pop_remove_btn', '', 1),
        confirmCallback: function () {
          return new Promise(function (resolve, reject) {
            // 加载loading弹窗
            LS.ui.loadingPopShow();
            LS.ajax({
              url: LS.ui.routes.changeCarItemtUrl,
              type: "POST",
              data: {
                id: cartId,
                quantity: 0,
              },
              success: function () {
                cartFn.request(false, 1);
                LS.ui.reporterSingle(LS.ui.reportMap["delCartItem"], self);
                resolve();
                // toast方法
								LS.ui.toastShowHandle(LS.$t('bag.remove_succ_toast', '', 1));
              },
              error: function (e) {
                LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
                reject();
              },
            });
          });
        },
      });
    },
    /**
     * 加载购物车item
     * @param {*} data
     * @returns
     */
    renderCartItem: function (data) {
      var cartItem = `
      <div class="cart-item_container">
        <div class="js-product-json" style="display: none;">
          {
            "id": ${data.id},
            "url": "${data.url}", 
            "productId": ${data.productId},
            "sku": ${data.sku},
            "quantity": ${data.quantity}
          }
        </div>
        <a href="${data.url}" class="cart-image_wrapper">
          <img
            class="cart-image"
            src="${data.url}"
            loading="lazy"
            width="108"
            height="142"
            object-fit="contain"
          />
          ${
            data.isSoldout
              ? `<div class="sold-out_wrapper">
              <div class="text">${LS.$t('bag.sold_out_text')}</div>
            </div>`
              : ""
          }
        </a>
  
        <div class="cart-item_right">
          <div class="cart-info_wrapper">
            <div class="price-wrapper">
              <div class="price">${data.currencyCode}${data.price}</div>
            </div>
            <div class="title">${data.title}</div>
            <div class="size-info">
              <div class="size">
               ${data.size}
              </div>
            </div>
            ${
              !data.isSoldout && data.max_quantity
                ? `<div class="cart-tip_max-quantity">Quantity changed to ${data.max_quantity}</div>`
                : ""
            }
          </div>
        </div>      
      </div>
      `;
      return cartItem;
    },
    /**
		 * 上报方法
		 */
    cartReportHandle: function(reportType, ext1, params) {
			// 获取购物车信息
			var data = {
				currency: LS.site.currency,
				total: $('#cart-total').text() || 0,
				sum: $('.web-header .ls-header-cart-count').text() || 0
      }
      var code = $('#ls-cart-coupon_code').text();
			// 上报
			LS.stat({
				eid: reportType,
				ext1: ext1,
        ext3: JSON.stringify(data),
        ext4: 'code=' + (code || 'NA'),
				...params
			});
    }
    
  };

	function init() {
		// 购物车页加载相关请求
		if (LS.site.page === 'cart') {
    	cartFn.request(true);
    } else {
      cartFn.getCartDataInfo(-1, -1, function(total) {
        if (LS.site.page === 'product') {
          cartFn.insertProductDiscountModule(total);
        }
      });
    }

    cartFn.bindEvent();
	}

	init();

  LS.ui.cartFn = {
    request: cartFn.request,
    getCartDataInfo: cartFn.getCartDataInfo,
    insertProductDiscountModule: cartFn.insertProductDiscountModule
  };
})();
